(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue", [], factory);
	else if(typeof exports === 'object')
		exports["vue"] = factory();
	else
		root["vue"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for base button.
 */
var Button = function (_PIXI$Container) {
    _inherits(Button, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  options  The options
     */
    function Button(options) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

        _this.tag = 'button';

        _this.isEnabled = true;
        _this.interactive = true;
        _this.buttonMode = true;

        if (options.tapped) {
            _this.tapped = options.tapped;
        }

        if (options.remainActive) {
            _this.remainActive = options.remainActive;
        } else {
            _this.remainActive = false;
        }

        _this.options = options;

        if (options.bgUrl) {
            _this.bg = new PIXI.Sprite.fromImage(options.bgUrl);
            _this.addChild(_this.bg);
        }

        if (typeof options.normalUrl === 'string') {
            _this.normal = new PIXI.Sprite.fromImage(options.normalUrl);
        } else {
            _this.normal = new PIXI.Sprite(options.normalUrl);
        }

        if (typeof options.hoverUrl === 'string') {
            _this.hover = new PIXI.Sprite.fromImage(options.hoverUrl);
        } else {
            _this.hover = new PIXI.Sprite(options.hoverUrl);
        }

        _this.addChild(_this.normal);
        _this.addChild(_this.hover);

        if (options.text) {
            _this.text = new PIXI.Text(options.text, options.textStyle);
            _this.addChild(_this.text);
            _this.text.x = Math.round((_this.normal.width - _this.text.width) / 2);
            _this.text.y = Math.round((_this.normal.height - _this.text.height) / 2);
        }

        if (options.tint) {
            _this.normal.tint = options.tint;
            _this.hover.tint = options.tint;
            if (_this.text) {
                _this.text.tint = options.tint;
            }
        }

        if (options.iconUrl) {
            _this.icon = new PIXI.Sprite.fromImage(options.iconUrl);
            _this.addChild(_this.icon);
            _this.icon.centerX();
            _this.icon.centerY();
        }

        _this.reset();
        return _this;
    }

    /**
     * Pixi Pointer event
     *
     * @param  {UIEvent}  e  The event
     */


    _createClass(Button, [{
        key: 'pointerdown',
        value: function pointerdown(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();
        }

        /**
         * Pixi Pointer event
         */

    }, {
        key: 'pointerover',
        value: function pointerover() {
            if (!this.isEnabled) {
                return;
            }

            if (this.hovered) {
                this.hovered();
            }

            this.hover.visible = true;
            this.normal.visible = false;

            this.isHovered = true;
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerup',
        value: function pointerup(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();

            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointertap',
        value: function pointertap(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();

            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerout',
        value: function pointerout() {
            this.reset();
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerupoutside',
        value: function pointerupoutside() {
            this.reset();
        }

        /**
         * Reset
         */

    }, {
        key: 'reset',
        value: function reset() {
            if (this.hover) {
                this.hover.visible = false;
            }
            if (this.normal) {
                this.normal.visible = true;
            }

            this.isHovered = false;
        }

        /**
         * Enable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.reset();
            this.interactive = true;
            this.buttonMode = true;
            this.alpha = 1;

            this.isEnabled = true;
        }

        /**
         * Disable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.reset();
            this.interactive = false;
            this.buttonMode = false;
            this.alpha = 0.5;

            this.isEnabled = false;
        }

        /**
         * @private
         * Button pressed action
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: '_tapped',
        value: function _tapped(e) {
            if (this.tapped) {
                this.tapped(e);
            } else {
                throw new Error('Button has no Action');
            }

            if (!this.remainActive) {
                this.disable();
            }
        }
    }, {
        key: 'startBlinking',
        value: function startBlinking() {
            var _this2 = this;

            if (this.blinkInterval) {
                return;
            }

            this.blinkInterval = window.setInterval(function () {
                if (_this2.isHovered || !_this2.isEnabled) {
                    return;
                }

                if (_this2.blinkActive) {
                    _this2.hover.visible = false;
                    _this2.normal.visible = true;
                    _this2.blinkActive = false;
                } else {
                    _this2.hover.visible = true;
                    _this2.normal.visible = false;
                    _this2.blinkActive = true;
                }
            }, this.options.blink * 1000);
        }
    }, {
        key: 'stopBlinking',
        value: function stopBlinking() {
            window.clearInterval(this.blinkInterval);
            this.blinkInterval = null;
            this.reset();
        }
    }]);

    return Button;
}(PIXI.Container);

exports.default = Button;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stats = __webpack_require__(14);

var _stats2 = _interopRequireDefault(_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class for canvas manager.
 */
var CanvasManager = function () {
    /**
     * @typedef {Object} CanvasManagerOptions
     * @property {Boolean} showFPS          - Whether to show the FPS counter
     * @property {Object} backgroundAnchor  - Coordinates of BG Anchor {x 0.5, y: 1}
     * @property {Number} transitionSpeed   - The speed of the parallax scroll
     * @property {Number} parallaxBgOffeset - The amount the BG should parallax scroll
     * @property {Number} defaultGameWidth  - The width the game starts width
     * @property {Number} defaultGameHeight - The height the game starts width
     */

    /**
     * Constructs the object.
     *
     * @param  {CanvasManagerOptions}  options        - The options
     * @param  {PIXI.Container}        bottomBarView  - The bottom bar view
     * @param  {PIXI.Sprite}           gameBg         - The game background
     */
    function CanvasManager(options, bottomBarView, gameBg) {
        var _this = this;

        _classCallCheck(this, CanvasManager);

        this.views = [];
        this.overlays = [];
        this.historyStates = [];
        this.isTransitioning = false;

        this.fixedAspect = options.fixedAspect;

        if (options.forceCanvas === undefined) {
            console.error('missing options.forceCanvas');
        }

        this.dpi = options.dpi;
        this.showFPS = options.showFPS; // true
        this.forceCanvas = options.forceCanvas; // true
        this.backgroundAnchor = options.backgroundAnchor;
        this.transitionSpeed = options.transitionSpeed;
        this.parallaxBgOffeset = options.parallaxBgOffeset;
        this.defaultGameWidth = options.defaultGameWidth;
        this.defaultGameHeight = options.defaultGameHeight;
        this.font = options.font;

        this.onPageVisibility = options.onPageVisibility;
        this.onResize = options.onResize;

        this.bottomBarView = bottomBarView;
        this.gameBg = gameBg;

        this.buttonOffset = 150;
        this.buttonPadding = 56;

        if (options.buttonOffset !== undefined) {
            this.buttonOffset = options.buttonOffset;
        }

        if (options.buttonPadding !== undefined) {
            this.buttonPadding = options.buttonPadding;
        }

        this.gameDimensions = {
            scale: 1,
            width: this.defaultGameWidth,
            height: this.defaultGameWidth
        };

        // History events
        window.onpopstate = function (e) {
            return _this.popHistory(e);
        };

        // document/window events
        window.SUGA.Device.resize(50, function (data) {
            return _this.sizeToFit(data);
        });
        window.SUGA.Device.pageVisibility(function (isVisible) {
            return _this.pageVisibility(isVisible);
        });
    }

    /**
     * Start rendering the canvas
     */


    _createClass(CanvasManager, [{
        key: 'renderCanvas',
        value: function renderCanvas() {
            this.canvasContainerEle = document.getElementById('canvas-container');
            this.canvasEle = document.getElementById('canvas');

            // stage options
            var rendererOptions = {
                view: this.canvasEle,
                transparent: true,
                autoResize: true,
                antialias: false,
                resolution: this.dpi,
                clearBeforeRender: false,
                forceCanvas: this.forceCanvas
            };

            var w = this.defaultGameWidth;
            var h = this.defaultGameHeight;

            // create renderer
            this.app = new PIXI.Application(w, h, rendererOptions);
            this.renderer = this.app.renderer;
            this.renderer.backgroundColor = 0xFF66CC;

            // add global ticker
            window.__ticker = this.app.ticker;

            // add stage
            this.outerStage = this.app.stage;
            this.innerStage = new PIXI.Container();
            this.outerStage.addChild(this.innerStage);

            // const bg = new PIXI.Graphics()
            // bg.beginFill(0x000000, 0.5)
            // bg.drawRect(0,0,w,h)
            // bg.endFill()
            // this.innerStage.addChild(bg)

            this.disableScrolling();

            // show FPS stat
            if (this.showFPS) {
                var stats = new _stats2.default();

                document.body.appendChild(stats.dom);
                this.app.ticker.add(function () {
                    return stats.update();
                });
            }

            this.addBackground(w, h);
            this.addUiBars();
        }

        /**
         * Shows the canvas ele.
         */

    }, {
        key: 'showCanvasEle',
        value: function showCanvasEle() {
            this.canvasEle.style.display = 'block';
        }

        /**
         * fits views to dimensions
         *
         * @return {Object}  Returns the new dimensions
         */

    }, {
        key: 'sizeToFit',
        value: function sizeToFit() {
            var rendererH = void 0;
            var rendererW = void 0;

            if (!this.canvasEle) {
                return this.gameDimensions;
            }

            // get viewport dimensions
            var vp = window.SUGA.Device.getViewport();

            var gW = this.defaultGameWidth;
            var gH = this.defaultGameHeight;

            // build ratios
            var widthGrowthRatio = vp.w / gW;
            var heightGrowthRatio = vp.h / gH;

            if (!this.fixedAspect) {
                // determine the ratio that fits
                if (heightGrowthRatio > widthGrowthRatio) {
                    rendererW = gW;
                    rendererH = Math.round(vp.h * gW / vp.w);
                } else {
                    rendererW = Math.round(vp.w * gH / vp.h);
                    rendererH = gH;
                }

                this.renderer.resize(rendererW, rendererH);

                this.canvasEle.style.width = vp.w + 'px';
                this.canvasEle.style.height = vp.h + 'px';

                this.centerBg(rendererW, rendererH);
            } else {
                var w = void 0;
                var h = void 0;

                // determine the ratio that fits
                if (heightGrowthRatio < widthGrowthRatio) {
                    w = Math.round(gW * heightGrowthRatio);
                    h = vp.h;
                } else {
                    h = Math.round(gH * widthGrowthRatio);
                    w = vp.w;
                }

                this.canvasEle.style.width = w + 'px';
                this.canvasEle.style.height = h + 'px';

                rendererW = gW;
                rendererH = gH;
            }

            this.canvasContainerEle.style.width = vp.w + 'px';
            this.canvasContainerEle.style.height = vp.h + 'px';

            // #set new gameDimensions
            var ratio = vp.w / rendererW;

            // center stage
            var x = Math.round((rendererW - gW) / 2);
            var y = Math.round((rendererH - gH) / 2);

            y = 0;
            this.innerStage.position.set(x, y);

            this.rendererWidth = rendererW;
            this.gameWidth = this.defaultGameWidth;

            this.gameDimensions = {
                scale: ratio,
                width: rendererW,
                height: rendererH,
                defaultWidth: this.defaultGameWidth,
                defaultHeight: this.defaultGameHeight,
                viewportWidth: vp.w,
                viewportHeight: vp.h,
                stage: {
                    x: this.innerStage.x,
                    y: this.innerStage.y
                }
            };

            if (this.bottomBarView) {
                this.bottomBarView.resize(rendererW, rendererH);
            }

            if (this.settingsView) {
                this.settingsView.resize(this.gameDimensions);
            }

            if (this.foregroundView && this.foregroundView.resize) {
                this.foregroundView.resize(this.gameDimensions);
            }

            if (this.backgroundView && this.backgroundView.resize) {
                this.backgroundView.resize(this.gameDimensions);
            }

            this.resizeViews(this.gameDimensions);

            this.onResize(this.gameDimensions);

            return this.gameDimensions;
        }

        /**
         * Place buttons for all views and overlays
         *
         * @param  {Object}  gameDimensions  The game dimensions
         */

    }, {
        key: 'resizeViews',
        value: function resizeViews(gameDimensions) {
            var allViews = this.views.concat(this.overlays);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = allViews[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var view = _step.value;

                    this.resizeView(view, gameDimensions);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'resizeView',
        value: function resizeView(view, gameDimensions) {
            if (view.resize) {
                view.resize(gameDimensions);
            }

            if (view.buttons) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = view.buttons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var button = _step2.value;

                        this.placeButton(button, gameDimensions.height);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }

        /**
         * Reposition buttons Y axis
         *
         * @param  {PIXI.DisplayObject}  button  The button
         * @param  {Number}              height  The game height
         * @return {PIXI.DisplayObject}  The modified button
         */

    }, {
        key: 'placeButton',
        value: function placeButton(button, height) {
            if (!button) {
                return null;
            }

            button.y = Math.round(height - this.buttonOffset - this.buttonPadding * button.order);

            button.centerX();

            return button;
        }

        /**
         * Called when the page becomes visible or not
         *
         * @param  {boolean}  isVisible  Indicates if visible
         */

    }, {
        key: 'pageVisibility',
        value: function pageVisibility(isVisible) {
            if (isVisible) {
                this.app.start();
            } else {
                this.app.stop();
            }

            if (this.onPageVisibility) {
                this.onPageVisibility(isVisible);
            }
        }

        /**
         * Adds a background.
         *
         * @param  {Number}  w  width
         * @param  {Number}  h  height
         */

    }, {
        key: 'addBackground',
        value: function addBackground(w, h) {
            this.gameBg.anchor.set(this.backgroundAnchor.x, this.backgroundAnchor.y);
            this.outerStage.addChildAt(this.gameBg, 0);

            if (!this.fixedAspect) {
                this.centerBg(w, h);
            } else {
                // this.gameBg.width = w
                // this.gameBg.height = h
            }
        }

        /**
         * FIXME - Should be more abstracted
         * Adds a settings view.
         *
         * @param  {PIXI.Container}  settingsView  The settings view
         */

    }, {
        key: 'addSettingsView',
        value: function addSettingsView(settingsView) {
            this.settingsView = settingsView;
            this.outerStage.addChildAt(this.settingsView, 2);
        }

        /**
         * Adds user interface bars.
         */

    }, {
        key: 'addUiBars',
        value: function addUiBars() {
            this.outerStage.addChild(this.bottomBarView);
        }

        /**
         * Brings UI to top Z index
         */

    }, {
        key: 'bringUiToFront',
        value: function bringUiToFront() {
            if (this.settingsView) {
                this.settingsView.bringToFront();
            }
            this.bottomBarView.bringToFront();
        }

        /**
         * Adds a background view.
         *
         * @param  {PIXI.Sprite}    backgroundView  The background view
         * @param  {Function}  cb   Handler after background view is completed
         */

    }, {
        key: 'addBackgroundView',
        value: function addBackgroundView(backgroundView) {
            this.backgroundView = backgroundView;
            this.outerStage.addChildAt(this.backgroundView, 1);
        }

        /**
         * Adds a foreground view.
         *
         * @param  {PIXI.Sprite}    foregroundView  The foreground view
         * @param  {Function}  cb   Handler after foreground view is completed
         */

    }, {
        key: 'addForegroundView',
        value: function addForegroundView(foregroundView) {
            this.foregroundView = foregroundView;
            this.outerStage.addChildAt(this.foregroundView, 3);
        }

        /**
         * Center the background in the view
         *
         * @param  {Number}  width   The width
         * @param  {Number}  height  The height
         */

    }, {
        key: 'centerBg',
        value: function centerBg(width, height) {
            if (this.gameBg) {
                this.scaleToFill(width, height, this.gameBg, this.parallaxBgOffeset);

                this.gameBg.originalX = this.gameBg.position.x;
            }
        }

        /**
         * Scale sprite to fill canvas
         *
         * @param  {Number}       width            The width
         * @param  {Number}       height           The height
         * @param  {PIXI.Sprite}  sprite           The sprite
         * @param  {number}       parallaxPadding  The parallax padding
         */

    }, {
        key: 'scaleToFill',
        value: function scaleToFill(width, height, sprite, parallaxPadding) {
            var ratio = void 0;
            var rW = width + parallaxPadding;
            var rH = height;
            var bgW = sprite.texture.width;
            var bgH = sprite.texture.height;

            if (this.backgroundAnchor.x > 0) {
                rW = rW + parallaxPadding / this.backgroundAnchor.x;
            }

            var ratioW = rW / bgW;
            var ratioH = rH / bgH;

            var rAspect = rW / rH;
            var bgAspect = bgW / bgH;

            if (rAspect > bgAspect) {
                ratio = ratioW;
            } else {
                ratio = ratioH;
            }

            // center
            var x = Math.floor(rW * this.backgroundAnchor.x) - (rW - width - parallaxPadding) / 2;
            var y = Math.floor(rH * this.backgroundAnchor.y);

            sprite.scale.set(ratio, ratio);

            sprite.position.set(x, y);
        }
    }, {
        key: 'addView',
        value: function addView(view) {
            // put view on stage
            this.innerStage.addChild(view);

            // add view to our stack
            this.views.push(view);
        }

        /**
         * Pushes a view.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: 'pushView',
        value: function pushView(view) {
            var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!animate) {
                this.addView(view);
                return;
            }

            // prevent mulitple views in the overlay stack
            if (this.isViewShowing(view.name)) {
                return;
            }

            this._pushView(view);

            this.bringUiToFront();
        }

        /**
         * @private
         * Pushes a view.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: '_pushView',
        value: function _pushView(view) {
            var _this2 = this;

            var currentView = void 0;

            // only push one view at a time
            if (this.isTransitioning) {
                return;
            }
            this.isTransitioning = true;

            // if we are pushing an html page above the canvas
            if (view.isHTML) {
                window.SUGA.Reality.canShowRealityCheck(false);
            }

            // is this the root view
            var isRootView = this.views.length < 1;

            // fire event on view, if defined
            if (view.willShow) {
                view.willShow();
            }

            // if this will not be the first view in the stack
            // then we will animate its movement
            if (!isRootView) {
                // add a push state
                this.pushHistory(view.name);

                // put view just out of screen to the right
                view.x = this.rendererWidth;

                // get current view
                currentView = window.UTIL.lastItem(this.views);

                // make view non-interactive
                currentView.interactiveChildren = false;

                // make static snap shot of view
                // currentView.cacheAsBitmap = true

                // fire event on previous view, if defined
                if (currentView.willHide) {
                    currentView.willHide();
                }
            }

            // put view on stage
            this.innerStage.addChild(view);

            // add view to our stack
            this.views.push(view);

            // align stuff before we push it
            this.resizeView(view, this.gameDimensions);

            // dont animate if this the first view
            if (isRootView) {
                if (view.didShow) {
                    view.didShow();
                }

                this.isTransitioning = false;

                return;
            }

            // calculate parallax x offset
            var newX = this.gameBg.position.x - this.parallaxBgOffeset;

            // animate background parallax
            TweenMax.to(this.gameBg, this.transitionSpeed / 1000, { x: newX });

            // slide in new view
            var options = {
                x: 0,

                onUpdate: function onUpdate() {
                    if (view.showingProgress) {
                        var ratio = view.x / _this2.rendererWidth;
                        var domX = window.innerWidth * ratio;

                        view.showingProgress(domX);
                    }
                },

                onComplete: function onComplete() {
                    if (view.didShow) {
                        view.didShow();
                    }

                    _this2.isTransitioning = false;
                }
            };

            TweenMax.to(view, this.transitionSpeed / 1000, options);

            // slide out old view
            options = {

                x: -this.innerStage.x - this.gameWidth,

                onComplete: function onComplete() {
                    currentView.renderable = false;

                    if (currentView.didHide) {
                        currentView.didHide();
                    }
                }
            };

            TweenMax.to(currentView, this.transitionSpeed / 1000, options);
        }
    }, {
        key: 'removeView',
        value: function removeView() {
            var view = this.views.pop();
            view.removeSelf();
        }

        /**
         * Pop view from stack
         *
         * @return {Boolean}  did we pop a view
         */

    }, {
        key: 'popView',
        value: function popView() {
            var _this3 = this;

            var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this.isTransitioning || this.views.length < 1) {
                return false;
            }

            if (!animate) {

                this.removeView();
                return;
            }

            this.isTransitioning = true;

            var isRootView = this.views.length === 1;

            var view = this.views.pop();

            if (view.willHide) {
                view.willHide();
            }

            // if we are popping an html page
            if (view.isHTML) {
                window.SUGA.Reality.canShowRealityCheck(true);
            }

            var nextView = window.UTIL.lastItem(this.views);

            if (nextView) {
                if (nextView.willShow) {
                    nextView.willShow();
                }
                nextView.interactiveChildren = true;
                nextView.renderable = true;
            }
            // // nextView.cacheAsBitmap = false

            // if (this.views.length === 1)
            // {
            //     this.rootViewShown();
            // }

            if (isRootView) {
                if (view.didHide) {
                    view.didHide();
                }
                view.removeSelf();
                this.isTransitioning = false;

                return true;
            }

            // animate background parallax
            TweenMax.to(this.gameBg, this.transitionSpeed / 1000, { x: this.gameBg.originalX });

            // slide in new view
            var options = {
                x: this.rendererWidth,
                onUpdate: function onUpdate() {
                    if (view.showingProgress) {
                        var ratio = view.x / _this3.rendererWidth;
                        var domX = window.innerWidth * ratio;

                        view.showingProgress(domX);
                    }
                },
                onComplete: function onComplete() {
                    if (view.didHide) {
                        view.didHide();
                    }

                    view.removeSelf();
                }
            };

            TweenMax.to(view, this.transitionSpeed / 1000, options);

            // slide out old view
            options = {
                x: 0,
                onComplete: function onComplete() {
                    if (nextView.didShow) {
                        nextView.didShow();
                    }

                    _this3.isTransitioning = false;
                }
            };

            TweenMax.to(nextView, this.transitionSpeed / 1000, options);

            return true;
        }

        /**
         * Pop all views
         */

    }, {
        key: 'popAllViews',
        value: function popAllViews() {
            for (var i = this.views.length - 1; i >= 0; i -= 1) {
                this.popView();
            }
        }

        /**
         * Determines if view showing.
         *
         * @param  {boolean}  name  The name
         * @return {boolean}  True if view showing, False otherwise.
         */

    }, {
        key: 'isViewShowing',
        value: function isViewShowing(name) {
            var v = window.UTIL.lastItem(this.views);

            if (v && v.name && v.name === name) {
                return true;
            }

            return false;
        }

        /**
         * Pushes an overlay.
         *
         * @param  {PIXI.Container}  overlayView  The overlay view
         */

    }, {
        key: 'pushOverlay',
        value: function pushOverlay(overlayView) {
            // prevent mulitple views in the overlay stack
            if (this.isOverlayShowing(overlayView.name)) {
                return;
            }

            this._pushOverlay(overlayView);

            this.bringUiToFront();
        }

        /**
         * @private
         *
         * Pushes an overlay.
         *
         * @param  {PIXI.Container}  overlayView  The overlay view
         */

    }, {
        key: '_pushOverlay',
        value: function _pushOverlay(overlayView) {
            this.disableUserActions();

            var currentView = window.UTIL.lastItem(this.views);

            if (currentView) {
                currentView.interactiveChildren = false;
            }

            this.outerStage.addChild(overlayView);

            this.overlays.push(overlayView);

            // align stuff before we push it
            this.resizeView(overlayView, this.gameDimensions);
        }

        /**
         * Pop an overlay
         *
         * @param  {boolean}  suppressEvents  The suppress events
         * @return {boolean}  { description_of_the_return_value }
         */

    }, {
        key: 'popOverlay',
        value: function popOverlay(suppressEvents) {
            var _this4 = this;

            if (!suppressEvents) {
                suppressEvents = false;
            }

            if (this.overlays.length < 1) {
                return false;
            }

            var isLastOverlay = this.overlays.length === 1;

            var view = window.UTIL.lastItem(this.views);

            if (isLastOverlay) {
                if (view.willShow) {
                    view.willShow();
                }
            }

            var overlayView = this.overlays.pop();

            if (!suppressEvents) {
                this.enableUserActions();
            }

            var currentView = window.UTIL.lastItem(this.views);

            clearTimeout(this.overlayTimer);
            currentView.interactiveChildren = true;
            currentView.filters = null;

            overlayView.hide(function () {
                _this4.outerStage.removeChild(overlayView);

                if (isLastOverlay && view.didShow) {
                    view.didShow();
                }
            });

            return true;
        }

        /**
         * Pup all the overlays
         *
         * @param  {Boolean}  suppressEvents  The suppress events
         */

    }, {
        key: 'popAllOverlays',
        value: function popAllOverlays(suppressEvents) {
            for (var i = this.views.length - 1; i >= 0; i -= 1) {
                this.popOverlay(suppressEvents);
            }
        }

        /**
         * Determines if overlay showing.
         *
         * @param  {String}  name  The name
         * @return {Boolean}  True if overlay showing, False otherwise.
         */

    }, {
        key: 'isOverlayShowing',
        value: function isOverlayShowing(name) {
            var o = window.UTIL.lastItem(this.overlays);

            if (o && o.name && o.name === name) {
                return true;
            }

            return false;
        }

        /**
         * Determines if it has overlay.
         *
         * @return {boolean}  True if has overlay, False otherwise.
         */

    }, {
        key: 'hasOverlay',
        value: function hasOverlay() {
            return this.overlays.length > 0;
        }

        /**
         * Pushes an initialize history.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: 'pushInitHistory',
        value: function pushInitHistory(view) {
            this.historyStates.push(view);

            history.pushState(this.historyStates, 'sub-menu', null);
        }

        /**
         * Pushes a history.
         *
         * @param  {PIXI.Container}  view  The view
         */

    }, {
        key: 'pushHistory',
        value: function pushHistory(view) {
            this.historyStates.push(view);

            history.replaceState(this.historyStates, 'sub-menu', null);
        }

        /**
         * Pop a history
         */

    }, {
        key: 'popHistory',
        value: function popHistory() {
            if (this.historyStates.length > 1) {
                this.historyStates.pop();

                window.history.pushState(this.historyStates, 'sub-menu', null);
                this.popView();

                return;
            }

            window.history.back();
        }

        /**
         * Navigate back
         */

    }, {
        key: 'back',
        value: function back() {
            this.popHistory();
        }

        /**
         * Force a real back navigation
         */

    }, {
        key: 'forceBack',
        value: function forceBack() {
            this.historyStates = [];

            window.history.back();
        }

        /**
         * User hit space bar
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'spacebarHit',
        value: function spacebarHit(e) {
            if (this.isTransitioning) {
                return;
            }

            e.preventDefault();

            var tmp = this.views.concat(this.overlays);

            for (var i = tmp.length - 1; i >= 0; i--) {

                var view = tmp[i];

                if (view && view.spacebarHit) {
                    view.spacebarHit(e);

                    return;
                }
            }
        }

        /**
         * Enables the user actions.
         */

    }, {
        key: 'enableUserActions',
        value: function enableUserActions() {
            var _this5 = this;

            this.bottomBarView.enableNavigationButtons();

            this.innerStage.interactiveChildren = true;

            document.onkeydown = function (e) {
                e = e || window.event;

                if (e.keyCode === 32) {
                    _this5.spacebarHit(e);
                }
            };
        }

        /**
         * Disables the user actions.
         */

    }, {
        key: 'disableUserActions',
        value: function disableUserActions() {
            this.innerStage.interactiveChildren = false;
            this.bottomBarView.disableNavigationButtons();
            document.onkeydown = null;
        }

        /**
         * Enables the scrolling.
         */

    }, {
        key: 'enableScrolling',
        value: function enableScrolling() {
            this.renderer.plugins.interaction.autoPreventDefault = false;

            this.canvasEle.style['touch-action'] = 'pan-y';
        }

        /**
         * Disables the scrolling.
         */

    }, {
        key: 'disableScrolling',
        value: function disableScrolling() {
            this.renderer.plugins.interaction.autoPreventDefault = true;

            this.canvasEle.style['touch-action'] = 'none';
        }
    }]);

    return CanvasManager;
}();

exports.default = CanvasManager;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function extend(dpi) {
    function bringToFront() {
        if (this.parent) {
            var parent = this.parent;


            parent.removeChild(this);
            parent.addChild(this);
        }
    }
    window.PIXI.DisplayObject.prototype.bringToFront = bringToFront;

    function zSort() {
        function sortIt(a, b) {
            if (a.z < b.z) {
                return -1;
            }
            if (a.z > b.z) {
                return 1;
            }

            return 0;
        }

        this.children = this.children.sort(sortIt);
    }
    window.PIXI.DisplayObject.prototype.zSort = zSort;

    function getByTag(tag) {
        if (!this.children || !this.children.length) {
            return null;
        }

        var objects = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(this.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var child = _step.value;

                if (child.tag === tag) {
                    objects.push(child);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (objects.length > 1) {
            return objects;
        }

        if (objects.length === 1) {
            return objects[0];
        }

        return null;
    }
    window.PIXI.DisplayObject.prototype.getByTag = getByTag;

    function removeAllChildren() {
        while (this.children[0]) {
            this.children[0].removeChildren();
            this.removeChild(this.children[0]);
        }
    }
    window.PIXI.DisplayObject.prototype.removeAllChildren = removeAllChildren;

    function removeSelf() {
        if (this.parent) {
            this.parent.removeChild(this);
        }
    }
    window.PIXI.DisplayObject.prototype.removeSelf = removeSelf;

    function centerX(width) {
        if (!width) {
            if (this.parent) {
                width = this.parent.width;
            } else {
                return;
            }
        }

        var anchorX = 0;

        if (this.anchor) {
            anchorX = this.anchor.x;
        }

        this.position.x = Math.floor((width - this.width) / 2 + this.width * anchorX);
    }
    window.PIXI.Container.prototype.centerX = centerX;

    function centerY(height) {
        if (!height) {
            if (this.parent) {
                height = this.parent.height;
            } else {
                return;
            }
        }

        var anchorY = 0;

        if (this.anchor) {
            anchorY = this.anchor.y;
        }

        this.position.y = Math.floor((height - this.height) / 2 + this.width * anchorY);
    }
    window.PIXI.Container.prototype.centerY = centerY;

    function centerAtPoint(x, y) {
        this.x = Math.round(x - this.width / 2) + 1;

        this.y = Math.round(y - this.height / 2);
    }
    window.PIXI.Container.prototype.centerAtPoint = centerAtPoint;

    function clarify() {
        this.resolution = dpi;

        this.updateText();
    }
    window.PIXI.Text.prototype.clarify = clarify;

    function sizeToFit(width, scaleUp) {
        if (scaleUp === null || scaleUp === undefined) {
            scaleUp = true;
        }

        var w = this.width;
        var h = this.height;

        while (this.width > width) {
            this.style.fontSize--;
        }

        var ratio = this.width / w;
        var change = h - this.height * ratio;

        this.style.lineHeight -= change;
    }
    window.PIXI.Text.prototype.sizeToFit = sizeToFit;

    function timer(secs, cb) {
        var state = {
            stop: false,
            progress: 0
        };

        var ticker = function ticker(delta) {
            state.progress += delta;
            var elapsed = state.progress / 60;

            if (state.stop || elapsed > secs) {
                window.PIXI.ticker.shared.remove(ticker);
                cb();
            }
        };

        window.PIXI.ticker.shared.add(ticker);

        state.clear = function () {
            window.PIXI.ticker.shared.remove(ticker);
            state.stop = true;
        };

        return state;
    }

    window.PIXI.setTimeout = timer;
}

exports.extend = extend;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _buttons = __webpack_require__(11);

var _buttons2 = _interopRequireDefault(_buttons);

var _autoplayBar = __webpack_require__(9);

var _autoplayBar2 = _interopRequireDefault(_autoplayBar);

var _counter = __webpack_require__(12);

var _counter2 = _interopRequireDefault(_counter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bottom bar visualization of the data that model contains.
 */
var BottomBarView = function (_PIXI$Container) {
    _inherits(BottomBarView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  gameModel        The game model
     * @param  {CurrencyManager}  currencyManager  The currency manager
     */
    function BottomBarView(gameModel, options, currencyManager) {
        _classCallCheck(this, BottomBarView);

        var _this = _possibleConstructorReturn(this, (BottomBarView.__proto__ || Object.getPrototypeOf(BottomBarView)).call(this));

        _this.w = 360;
        _this.h = 45;
        _this.bgAlpha = options.bgAlpha;
        _this.winAmount = 0;
        _this.totalPaid = 0;
        _this.textYOffset = 18;
        _this.textGap = 10;
        _this.showTickets = false;
        _this.infoGroupWidth = 80;
        _this.interactive = true;
        _this.counterTween = null;

        if (options.infoGroupWidth) {
            _this.infoGroupWidth = options.infoGroupWidth;
        }

        if (options.bgAlpha === undefined) {
            console.error('missing options.bgAlpha');
        }

        _this.gameModel = gameModel;

        var ticketsLabel = __t.str('Tickets left').toUpperCase();
        var betlabel = __t.str('Bet').toUpperCase();
        var balanceLabel = __t.str('Balance').toUpperCase();
        var totalLabel = __t.str('Total paid').toUpperCase();

        var letterSpacing = _this.determineLetterSpacing(2, 10, [ticketsLabel, betlabel, balanceLabel, totalLabel]);

        _this.labelStyle = {
            fontFamily: _this.gameModel.font,
            fontSize: 9,
            fontWeight: 400,
            fill: '#FFFFFF',
            wordWrap: false,
            lineHeight: 15,
            padding: 2,
            letterSpacing: letterSpacing
        };

        _this.valueStyle = {
            fontFamily: _this.gameModel.font,
            fontSize: 12,
            fontWeight: 400,
            fill: _this.gameModel.primaryColor,
            wordWrap: false,
            lineHeight: 15,
            padding: 2
        };

        _this.currencyManager = currencyManager;

        _this._setDimension(_this.gameModel.gameWidth, _this.gameModel.gameHeight);

        _this.showTickets = _this.gameModel.isBasketMode();
        _this.showHomeButton = _this.gameModel.showHomeButton;
        _this.showHelpButton = _this.gameModel.showHelpButton;

        _this.addAutoplayBar();
        _this.addBg();
        _this.addInfoContainer();

        var buttonOpts = {
            mute: gameModel.getMute(),
            primaryColor: gameModel.primaryColor,
            showHelpButton: gameModel.showHelpButton,
            showHomeButton: gameModel.showHomeButton,
            helpButtonHandler: options.onHelpClick,
            homeButtonHandler: options.onHomeClick,
            muteButtonHandler: options.onMuteClick,
            settingsButtonHandler: options.onSettingsClick,
            isBasketMode: _this.gameModel.isBasketMode(),
            fullscreenEnabled: options.fullscreenEnabled,
            fullscreenButtonHandler: options.onFullscreenClick
        };

        _this.buttonContainer = new _buttons2.default(buttonOpts);
        _this.addChild(_this.buttonContainer);

        var ticketX = 0;

        // prebought tickets
        if (_this.showTickets) {
            window.SUGA.Event.on('tickets', function (amount) {
                return _this.updateTicketCount(amount);
            });
            _this.addTickets(ticketsLabel, ticketX, _this.gameModel.getRoundsLeft());
            ticketX += _this.infoGroupWidth;
        }

        // buy from wallet
        else if (!_this.gameModel.dontShowStake) {

                var amount = _this.gameModel.getStake();

                try {
                    amount = _this.currencyManager.localize(amount, true, true);
                } catch (e) {
                    amount = '';
                }

                _this.addTickets(betlabel, ticketX, amount, options.onSettingsClick);
                ticketX += _this.infoGroupWidth;
            }

        if (options.showTotalPaid) {
            // total paid
            _this.addTotalPaid(totalLabel, ticketX);
            ticketX += _this.infoGroupWidth;
        }

        // balance
        if (!_this.gameModel.dontShowBalance) {
            _this.addBalance(balanceLabel, _this.gameModel.getBalance(), ticketX);
            window.SUGA.Event.on('balance', function (amount) {
                return _this.updateBalance(amount);
            });
            ticketX += _this.infoGroupWidth;
        }

        _this.infoContainerXOffset = ticketX;
        return _this;
    }

    /**
     * Sets the dimension.
     *
     * @param  {Number}  viewportWidth   The viewport width
     * @param  {Number}  viewportHeight  The viewport height
     */


    _createClass(BottomBarView, [{
        key: '_setDimension',
        value: function _setDimension(viewportWidth, viewportHeight) {
            this.w = viewportWidth;
            var y = viewportHeight - this.h;

            this.position.y = y;
        }

        /**
         * Adds a background.
         */

    }, {
        key: 'addBg',
        value: function addBg() {
            this.bg = new PIXI.Graphics();
            this.bg.beginFill(0x000000);
            this.bg.drawRect(0, 0, this.w, this.h);
            this.bg.endFill();
            this.bg.alpha = this.bgAlpha;
            this.addChildAt(this.bg, 1);
        }

        /**
         * Adds an information container.
         */

    }, {
        key: 'addInfoContainer',
        value: function addInfoContainer() {
            this.infoContainer = new PIXI.Container();
            this.addChild(this.infoContainer);
            this.infoContainer.x = this.width - this.infoGroupWidth * 2;
        }

        /**
         * Adds tickets.
         *
         * @param  {String}         label   The label
         * @param  {Number}         x       The x position
         * @param  {(PIXI|string)}  amount  The amount
         */

    }, {
        key: 'addTickets',
        value: function addTickets(label, x, amount, handler) {
            if (amount === null || amount === undefined) {
                amount = '';
            }

            var y = this.textYOffset;

            var container = new PIXI.Container();

            container.x = x;
            this.infoContainer.addChild(container);

            var bg = new PIXI.Graphics();

            bg.beginFill(0xFFCC66);
            bg.drawRect(0, 0, this.infoGroupWidth, this.h);
            bg.endFill();
            bg.alpha = 0;
            container.addChild(bg);

            if (!this.ticketLabel) {
                this.ticketLabel = new PIXI.Text(label, this.labelStyle);
            }

            container.addChild(this.ticketLabel);
            this.ticketLabel.centerX();
            this.ticketLabel.y = 11;
            this.ticketLabel.clarify();

            y = y + this.textGap;

            this.ticketValue = new PIXI.Text('' + amount, this.valueStyle);
            container.addChild(this.ticketValue);
            this.ticketValue.centerX();
            this.ticketValue.y = 21;
            this.ticketValue.clarify();

            if (!this.gameModel.isBasketMode() && this.settingsButtonHandler) {
                container.interactive = true;
                container.buttonMode = true;
                container.pointerup = function () {
                    return handler();
                };
            }
        }

        /**
         * Updates the ticket count
         *
         * @param  {Number}  amount  The amount
         */

    }, {
        key: 'updateTicketCount',
        value: function updateTicketCount(amount) {
            if (!this.gameModel.isBasketMode()) return;
            this.ticketValue.text = '' + amount;
        }
    }, {
        key: 'updateStake',
        value: function updateStake(stake) {
            if (this.gameModel.isBasketMode()) return;
            var amount = this.currencyManager.localize(stake, true, true);

            this.ticketValue.text = '' + amount;
            this.ticketValue.centerX();
        }

        /**
         * Adds a balance.
         *
         * @param  {Number}  amount  The amount
         * @param  {Number}  x       The x position
         */

    }, {
        key: 'addBalance',
        value: function addBalance(label, amount, x) {
            var _this2 = this;

            var y = this.textYOffset;

            var container = new PIXI.Container();

            container.x = x;
            this.infoContainer.addChild(container);

            var bg = new PIXI.Graphics();

            bg.beginFill(0xFFCC66);
            bg.drawRect(0, 0, this.infoGroupWidth, this.h);
            bg.endFill();
            bg.alpha = 0;
            container.addChild(bg);

            if (!this.balanceLabel) {
                this.balanceLabel = new PIXI.Text(label, this.labelStyle);
            }
            container.addChild(this.balanceLabel);
            this.balanceLabel.centerX();
            this.balanceLabel.y = 11;
            this.balanceLabel.clarify();

            y = y + this.textGap;

            var formatter = function formatter(amount) {
                if (amount === null || amount === undefined || amount < 0) {
                    return '';
                } else {
                    return _this2.currencyManager.localize(amount, true, true);
                }
            };

            var currencyMultiplier = this.gameModel.getCurrencyMultiplier();

            this.balanceValue = new _counter2.default('', this.valueStyle, formatter, currencyMultiplier, 1000);
            container.addChild(this.balanceValue);
            this.balanceValue.centerX();
            this.balanceValue.y = 21;
            this.balanceValue.clarify();

            this.setBalance(amount);
        }

        /**
         * Finish balance animation instantly
         */

    }, {
        key: 'instantFinishBalance',
        value: function instantFinishBalance() {

            return this.balanceValue.instantFinish();
        }

        /**
         * { function_description }
         *
         * @param  {Number}    newBalance  The new balance
         * @param  {Function}  cb          { parameter_description }
         */

    }, {
        key: 'updateBalance',
        value: function updateBalance(newBalance, cb) {
            if (!this.balanceValue) return;

            var newCount = {
                animate: newBalance.animate,
                count: newBalance.balance
            };
            return this.balanceValue.updateCount(newCount, cb);
        }

        /**
         * Sets the balance.
         *
         * @param  {(number|string)}  amount  The amount
         * @return {boolean}          { description_of_the_return_value }
         */

    }, {
        key: 'setBalance',
        value: function setBalance(amount) {
            if (!this.balanceValue) return;
            return this.balanceValue.setCount(amount);
        }

        /**
         * Center's the balance label
         */

    }, {
        key: 'centerBalance',
        value: function centerBalance() {
            if (!this.balanceValue) return;
            return this.balanceValue.centerX();
        }

        /**
         * Adds a balance.
         *
         * @param  {Number}  amount  The amount
         * @param  {Number}  x       The x position
         */

    }, {
        key: 'addTotalPaid',
        value: function addTotalPaid(label, x) {
            var _this3 = this;

            var y = this.textYOffset;

            var container = new PIXI.Container();
            container.x = x;
            this.infoContainer.addChild(container);

            var bg = new PIXI.Graphics();

            bg.beginFill(0xCCFF66);
            bg.drawRect(0, 0, this.infoGroupWidth, this.h);
            bg.endFill();
            bg.alpha = 0;
            container.addChild(bg);

            if (!this.totalPaidLabel) {
                this.totalPaidLabel = new PIXI.Text(label, this.labelStyle);
            }
            container.addChild(this.totalPaidLabel);
            this.totalPaidLabel.centerX();
            this.totalPaidLabel.y = 11;
            this.totalPaidLabel.clarify();

            y = y + this.textGap;

            var formatter = function formatter(amount) {
                if (amount === null || amount === undefined || amount < 0) {
                    return '';
                } else {
                    return _this3.currencyManager.localize(amount, true, true);
                }
            };

            var currencyMultiplier = this.gameModel.getCurrencyMultiplier();

            this.totalPaidValue = new _counter2.default('-', this.valueStyle, formatter, currencyMultiplier, 1000);
            container.addChild(this.totalPaidValue);
            this.totalPaidValue.centerX();
            this.totalPaidValue.y = 21;
            this.totalPaidValue.clarify();
        }
    }, {
        key: 'updateTotalPaid',
        value: function updateTotalPaid(amount, cb) {
            if (amount <= 0) return;

            this.totalPaid += amount;

            var newCount = {
                animate: true,
                count: this.totalPaid
            };

            return this.totalPaidValue.updateCount(newCount, cb);
        }
    }, {
        key: 'setTotalPaid',
        value: function setTotalPaid(amount) {

            return this.totalPaidValue.setCount(amount);
        }
    }, {
        key: 'resetTotalPaid',
        value: function resetTotalPaid() {

            this.totalPaidValue.instantFinish();
            this.totalPaid = 0;
            this.setTotalPaid(0);
        }
    }, {
        key: 'addAutoplayBar',
        value: function addAutoplayBar() {
            var options = {
                width: this.w,
                height: 21,
                font: this.gameModel.font,
                primaryColor: this.gameModel.primaryColor
            };

            this.autoplayBar = new _autoplayBar2.default(options);
            this.addChild(this.autoplayBar);
        }
    }, {
        key: 'updateAutoplay',
        value: function updateAutoplay(round, rounds) {
            this.autoplayBar.updateAutoplay(round, rounds);
        }
    }, {
        key: 'autoplayClearReason',
        value: function autoplayClearReason() {
            this.autoplayBar.autoplayClearReason();
        }
    }, {
        key: 'autoplayStopped',
        value: function autoplayStopped(reason) {
            this.autoplayBar.autoplayStopped(reason);
        }
    }, {
        key: 'toggleSettings',
        value: function toggleSettings(isOpen) {
            this.buttonContainer.toggleSettings(isOpen);
        }

        /**
         * Enables the navigation buttons.
         */

    }, {
        key: 'enableNavigationButtons',
        value: function enableNavigationButtons() {
            this.buttonContainer.enableNavigationButtons();
        }

        /**
         * Disables the navigation buttons.
         */

    }, {
        key: 'disableNavigationButtons',
        value: function disableNavigationButtons() {
            this.buttonContainer.disableNavigationButtons();
        }

        /**
         * Display the sound on button
         */

    }, {
        key: 'displaySoundOnButton',
        value: function displaySoundOnButton() {
            this.buttonContainer.displaySoundOnButton();
        }

        /**
         * Display the Sound off button
         */

    }, {
        key: 'displaySoundOffButton',
        value: function displaySoundOffButton() {
            this.buttonContainer.displaySoundOffButton();
        }

        /**
         * On resize
         *
         * @param  {Number}  rendererW  The renderer w
         * @param  {Number}  rendererH  The renderer h
         */

    }, {
        key: 'resize',
        value: function resize(rendererW, rendererH) {
            this._setDimension(rendererW, rendererH);
            this.removeChild(this.bg);
            this.bg = null;
            this.addBg();

            this.infoContainer.x = rendererW - this.infoContainerXOffset;
            this.infoContainer.bringToFront();

            this.autoplayBar.resize(rendererW);
        }
    }, {
        key: 'determineLetterSpacing',
        value: function determineLetterSpacing(defaultSpacing, maxLength, array) {
            var tmp = 0;
            array.forEach(function (label) {
                if (label.length > tmp) {
                    tmp = label.length;
                }
            });

            if (tmp <= maxLength) {
                return defaultSpacing;
            }

            return defaultSpacing * (maxLength / tmp);
        }
    }]);

    return BottomBarView;
}(PIXI.Container);

exports.default = BottomBarView;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Help visualization of the data that model contains.
 */
var HelpView = function (_PIXI$Container) {
    _inherits(HelpView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  size     The canvas size data
     * @param  {Object}  options  The options {helpUrl: , font:}
     */
    function HelpView(size, options) {
        _classCallCheck(this, HelpView);

        var _this = _possibleConstructorReturn(this, (HelpView.__proto__ || Object.getPrototypeOf(HelpView)).call(this));

        _this.name = 'HelpView';
        _this.visible = false;
        _this.isHTML = true;
        _this.balanceBarHeight = options.balanceBarHeight;
        _this.canClick = false;
        _this.isShowing = false;

        _this.backButtonHandler = options.onBackClick;

        _this.style = {
            fontFamily: options.font,
            fontSize: 22,
            fill: '#FFFFFF',
            align: 'center',
            lineHeight: 32
        };

        _this.addIframe(size, options.helpUrl);

        _this._size = size;
        return _this;
    }

    _createClass(HelpView, [{
        key: 'setBalanceBarHeight',
        value: function setBalanceBarHeight(h) {
            this.balanceBarHeight = h;
            this.resize(this._size);
        }

        /**
         * Animates the windows position when showing and hiding
         *
         * @param  {Nuber}  progress  The progress
         */

    }, {
        key: 'showingProgress',
        value: function showingProgress(progress) {
            progress = Math.round(progress);

            this.container.style.left = progress + 'px';
        }

        /**
         * Adds an iframe.
         *
         * @param  {Object}  size     The canvas size data
         * @param  {String}  helpUrl  The help url
         */

    }, {
        key: 'addIframe',
        value: function addIframe(size, helpUrl) {
            var _this2 = this;

            var vp = window.SUGA.Device.getViewport();
            var w = vp.w;


            this.iframe = document.createElement('iframe');
            this.iframe.src = helpUrl;
            // this.iframe.style.width = `${w}px`;

            this.container = document.getElementById('help-container');
            this.container.style.left = vp.w + 'px';
            this.container.style.bottom = Math.floor(this.balanceBarHeight * size.scale) + 'px';
            this.container.style.display = 'none';
            this.container.style.width = w + 'px';
            this.container.appendChild(this.iframe);

            // listen for the iframes button click
            var receiveMessage = function receiveMessage(event) {
                if (event.data === 'close-help') {
                    _this2.buttonClick();
                }
            };

            window.addEventListener('message', receiveMessage, false);
        }

        /**
         * On button click
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'buttonClick',
        value: function buttonClick(e) {
            if (!this.canClick) {
                return;
            }

            this.backButtonHandler();
            if (e) {
                e.stopPropagation();
            }
        }

        /**
         * Called on resize
         *
         * @param  {Object}  size  The size data
         */

    }, {
        key: 'resize',
        value: function resize(size) {
            if (!this.iframe) {
                return;
            }

            var w = size.viewportWidth;

            this.prevWidth = w;

            // this.iframe.style.width = `${w}px`;
            this.container.style.width = w + 'px';

            this.container.style.bottom = Math.floor(this.balanceBarHeight * size.scale) + 'px';

            this._size = size;
        }

        /**
         * Called before showing view
         */

    }, {
        key: 'willShow',
        value: function willShow() {
            this.container.style.display = 'block';
        }

        /**
         * Called after showing view
         */

    }, {
        key: 'didShow',
        value: function didShow() {
            this.canClick = true;
            this.isShowing = true;
        }

        /**
         * Called before hiding view
         */

    }, {
        key: 'willHide',
        value: function willHide() {
            this.canClick = false;
            this.isShowing = false;
        }

        /**
         * Called after hiding view
         */

    }, {
        key: 'didHide',
        value: function didHide() {
            this.container.style.display = 'none';
        }
    }]);

    return HelpView;
}(PIXI.Container);

exports.default = HelpView;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Menu visualization of the data that model contains.
 */
var MenuView = function (_PIXI$Container) {
    _inherits(MenuView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}           size             The size
     * @param  {Object}           options          The options
     * @param  {GameModel}        gameModel        The game model
     * @param  {ThemeImageModel}  themeImageModel  The theme image model
     */
    function MenuView(size, options, gameModel, themeImageModel, themeView) {
        _classCallCheck(this, MenuView);

        var _this = _possibleConstructorReturn(this, (MenuView.__proto__ || Object.getPrototypeOf(MenuView)).call(this));

        console.warn('this will be deprecated. move this view into your game');

        _this.canClick = false;
        _this.isRootView = true;
        _this.textY = 170;
        _this.buttons = [];

        _this.buttonHandler = options.buttonHandler;
        _this.showBuyMore = options.showBuyMore;
        _this.gameModel = gameModel;

        _this.addLogo(options.logoUrl, options.logoY, options.logoZ, size.defaultWidth);
        _this.addTagline(options.introText, options.introTextStyle, size.defaultWidth, size.height);

        var btnImages = {
            bgUrl: themeImageModel.btnBgImage,
            normalUrl: themeImageModel.btnNormalImage,
            hoverUrl: themeImageModel.btnHoverImage
        };

        _this.addPlayButton(btnImages);

        _this.addThemeView(themeView);

        _this.zSort();

        setTimeout(function () {
            _this.playButton.reset();

            if (options.isOutOfTickets && !_this.shouldShowBuyMore) {
                return _this.playButton.disable();
            }

            return _this.playButton.enable();
        }, 1);
        return _this;
    }

    /**
     * Adds a logo.
     *
     * @param  {String}  url     The logo url
     * @param  {Number}  logoY   The logo y position
     * @param  {Number}  width   The width
     */


    _createClass(MenuView, [{
        key: 'addLogo',
        value: function addLogo(url, logoY, logoZ, width) {
            if (this.logo) {
                this.logo.visible = true;

                return;
            }

            this.logo = new PIXI.Sprite.fromImage(url);

            this.logo.x = Math.round((width - this.logo.width) / 2);
            this.logo.y = logoY;
            this.logo.z = logoZ;

            this.addChild(this.logo);
        }

        /**
         * Adds a tagline.
         *
         * @param  {String}  introText  The intro text
         * @param  {String}  style      The intro text style
         * @param  {Number}  width      The width
         * @param  {Number}  height     The height
         */

    }, {
        key: 'addTagline',
        value: function addTagline(introText, style, width, height) {
            this.tagline = new PIXI.Text(introText, style);
            this.tagline.x = (width - this.tagline.width) / 2;
            this.tagline.y = height - this.textY;
            this.tagline.z = 3;
            this.addChild(this.tagline);

            this.tagline.clarify();
        }

        /**
         * Adds a theme view. e.g. A Specific caharacter
         *
         * @param  {ThemeImageModel}  themeImageModel  The theme image model
         */

    }, {
        key: 'addThemeView',
        value: function addThemeView(themeView) {
            this.themeView = themeView;

            this.addChild(this.themeView);
        }

        /**
         * Adds a play button.
         *
         * @param  {Object}  buttonImages  The button images
         */

    }, {
        key: 'addPlayButton',
        value: function addPlayButton(buttonImages) {
            var _this2 = this;

            if (this.playButton) {
                return;
            }

            this.playButton = new _button2.default(buttonImages);
            this.playButton.z = 3;
            this.playButton.tapped = function (e) {
                return _this2.playButtonClick(e);
            };
            this.playButton.order = 0;

            this.addChild(this.playButton);

            this.buttons.push(this.playButton);
        }

        /**
         * Play button click event handler
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'playButtonClick',
        value: function playButtonClick(e) {
            window.SUGA.Sound.play('spin-button');
            this.playButton.disable();

            // do we need to show it
            if (window.SUGA.Reality.canShowRealityCheck(true)) {
                return;
            }

            this.buttonHandler();

            if (e) {
                e.stopPropagation();
            }
        }

        /**
         * Spacbar press handler
         */

    }, {
        key: 'spacebarHit',
        value: function spacebarHit() {
            if (this.playButton.isEnabled) {
                this.playButtonClick();
            }
        }

        /**
         * Called when view will show
         */

    }, {
        key: 'willShow',
        value: function willShow() {
            if (this.gameModel.isOutOfTickets() && !this.showBuyMore) {
                this.playButton.disable();
            }

            this.playButton.enable();
        }

        /**
         * Called on resize
         *
         * @param  {Object}  size  The new size data
         */

    }, {
        key: 'resize',
        value: function resize(size) {
            if (this.tagline) {
                this.tagline.y = size.height - this.textY;
            }

            if (this.themeView) {
                this.themeView.y = size.height - this.themeView.height;
            }
        }
    }]);

    return MenuView;
}(PIXI.Container);

exports.default = MenuView;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Notification visualization of the data that model contains.
 */
var NotificationView = function (_PIXI$Container) {
    _inherits(NotificationView, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  size     The size
     * @param  {Object}  options  The options
     */
    function NotificationView(size, options) {
        _classCallCheck(this, NotificationView);

        var _this = _possibleConstructorReturn(this, (NotificationView.__proto__ || Object.getPrototypeOf(NotificationView)).call(this));

        _this.overlayAlpha = 0.9;
        _this.buttons = [];
        _this.offset = 100;
        _this.padding = 56;

        if (options.padding !== undefined) {
            _this.padding = options.padding;
        }

        _this.style = {
            fontSize: 28,
            fontWeight: 100,
            fill: '#FFFFFF',
            align: 'center',
            lineHeight: 32,
            wordWrap: true,
            wordWrapWidth: 280
        };

        _this.msgStyle = {
            fontSize: 13,
            fontWeight: 100,
            align: 'center',
            fill: '#FFFFFF',
            lineHeight: 17,
            wordWrap: true,
            wordWrapWidth: 280
        };

        _this.buttonTextStyle = {
            fontSize: 13,
            fontWeight: 100,
            align: 'center',
            fill: '#FFFFFF',
            lineHeight: 17,
            wordWrap: true,
            wordWrapWidth: 280
        };

        _this.style.fontFamily = options.font;
        _this.msgStyle.fontFamily = options.font;
        _this.buttonTextStyle.fontFamily = options.font;

        _this.font = options.font;
        _this.primaryColor = options.primaryColor;
        _this.defaultWidth = size.defaultWidth;

        _this.showCashierButton = options.showCashierButton;
        _this.showHistoryButton = options.showHistoryButton;
        _this.showHomeButton = options.showHomeButton;
        _this.showBuyMoreButton = options.showBuyMoreButton;

        _this.buttonImages = options.buttonImages;

        _this.addBg(size);

        _this.inner = new PIXI.Container();
        _this.inner.position.set(size.stage.x, size.stage.y);
        _this.addChild(_this.inner);
        return _this;
    }

    /**
     * Adds a background.
     *
     * @param  {Object}  size  The size
     */


    _createClass(NotificationView, [{
        key: 'addBg',
        value: function addBg(size) {
            this.overlay = new PIXI.Graphics();
            this.overlay.beginFill(0x000000);
            this.overlay.drawRect(0, 0, size.width, size.height);
            this.overlay.endFill();
            this.overlay.alpha = 0;

            this.addChildAt(this.overlay, 0);
        }

        /**
         * Setups the view
         *
         * @param  {String}  title    The title
         * @param  {String}  message  The message
         * @param  {Array}  actions  The actions
         * @param  {Object}  size     The size
         */

    }, {
        key: 'setup',
        value: function setup(title, message, actions, size, cb) {
            this.addText(title, message, size);
            this.addButtons(actions, size);
            this.resize(size);
            this.showOverlay(function () {
                cb();
            });
        }

        /**
         * Hides view
         *
         * @param  {Function}  cb  Completion Handler
         */

    }, {
        key: 'hide',
        value: function hide(cb) {
            var _this2 = this;

            // next tick
            setTimeout(function () {
                if (_this2.text) {
                    _this2.text.visible = false;
                }

                _this2.removeButtons();

                _this2.hideOverlay(function () {
                    if (cb) {
                        cb();
                    }
                });
            }, 1);
        }

        /**
         * Adds text.
         *
         * @param  {String}  title  The title
         * @param  {String}  msg    The message
         * @param  {Object}  size   The size
         */

    }, {
        key: 'addText',
        value: function addText(title, msg, size) {
            if (this.text) {
                this.updateText(title, msg, size);
                this.text.visible = true;

                return;
            }

            this.text = new PIXI.Container();
            this.inner.addChild(this.text);

            title = __t.str(title);
            msg = __t.str(msg);

            this.titleText = new PIXI.Text(title, this.style);
            this.titleText.y = this.padding;
            this.text.addChild(this.titleText);
            this.titleText.clarify();
            this.titleText.centerX(size.defaultWidth);

            this.messageText = new PIXI.Text(msg, this.msgStyle);
            this.messageText.y = this.padding + this.titleText.y + this.titleText.height;
            this.text.addChild(this.messageText);
            this.messageText.clarify();

            this.messageText.centerX(size.defaultWidth);
        }

        /**
         * Update text
         *
         * @param  {String}  title  The title
         * @param  {String}  msg    The message
         * @param  {Object}  size   The size
         */

    }, {
        key: 'updateText',
        value: function updateText(title, msg, size) {
            this.titleText.text = __t.str(title);
            this.titleText.clarify();
            this.titleText.centerX(this.defaultWidth);

            this.updateMsg(msg, size);
            this.messageText.y = this.padding + this.titleText.y + this.titleText.height;
        }

        /**
         * Update msg
         *
         * @param  {String}  msg    The message
         * @param  {Object}  size   The size
         */

    }, {
        key: 'updateMsg',
        value: function updateMsg(msg, size) {
            if (!this.messageText) {
                return;
            }
            this.messageText.text = __t.str(msg);
            this.messageText.clarify();

            this.messageText.centerX(this.defaultWidth);
        }

        /**
         * Adds buttons.
         *
         * @param  {Array}  actions  The actions
         * @param  {Object}  size     The size
         * @return {Array}   { description_of_the_return_value }
         */

    }, {
        key: 'addButtons',
        value: function addButtons(actions, size) {
            this.removeButtons();

            actions = actions.reverse();

            var place = 0;

            var result = [];

            for (var i = 0; i < actions.length; i += 1) {
                var action = actions[i];
                var item = void 0;

                if (this.addButton(action, place, i, actions.length, size)) {
                    item = place;
                    place += 1;
                }

                result.push(item);
            }

            return result;
        }

        /**
         * Adds a button.
         *
         * @param  {String|Function}  action  The action
         * @param  {Number}           place   The place
         * @param  {Number}           i       Index of incrment
         * @param  {Number}           total   The total
         * @param  {Object}           size    The size
         * @return {Boolean}          Whether the button was placed
         */

    }, {
        key: 'addButton',
        value: function addButton(options, place, i, total, size) {
            if (!this.canPerformAction(options.action)) {
                return false;
            }

            options.tapped = function () {
                window.SUGA.Event.trigger(options.action);
            };

            options.remainActive = true;

            options.normalUrl = this.buttonImages.normalUrl;
            options.hoverUrl = this.buttonImages.hoverUrl;
            options.font = this.font;
            options.textStyle = this.buttonTextStyle;

            if (i === total - 1) {
                options.tint = this.primaryColor;
            } else {
                options.tint = 0xaaaaaa;
            }

            var button = new _button2.default(options);

            button.order = place;
            this.addChild(button);

            this.buttons.push(button);

            return true;
        }

        /**
         * Removes buttons.
         */

    }, {
        key: 'removeButtons',
        value: function removeButtons() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Array.from(this.buttons)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var button = _step.value;

                    button.removeSelf();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.buttons = [];
        }

        /**
         * Shows the overlay.
         *
         * @param  {Function}  cb  Completion handler
         */

    }, {
        key: 'showOverlay',
        value: function showOverlay(cb) {
            var to = {
                alpha: this.overlayAlpha,
                onComplete: cb
            };

            window.TweenMax.to(this.overlay, 300 / 1000, to);
        }

        /**
         * Hides the overlay.
         *
         * @param  {Function}  cb  Completion handler
         */

    }, {
        key: 'hideOverlay',
        value: function hideOverlay(cb) {
            if (!this.overlay) {
                if (cb) {
                    cb();
                }

                return;
            }

            var to = {
                alpha: 0,
                onComplete: function onComplete() {
                    if (cb) {
                        cb();
                    }
                }
            };

            window.TweenMax.to(this.overlay, 300 / 1000, to);
        }

        /**
         * On resize
         *
         * @param  {Object}  size  The size
         */

    }, {
        key: 'resize',
        value: function resize(size) {
            this.removeChild(this.overlay);

            this.addBg(size);

            if (this.parent) {
                this.overlay.alpha = this.overlayAlpha;
            } else {
                this.overlay.alpha = 0;
            }

            if (this.inner) {
                this.inner.position.set(size.stage.x, size.stage.y);
            }
        }

        /**
         * Determines ability to perform action.
         *
         * @param  {String}   action  The action
         * @return {Boolean}  True if able to perform action, False otherwise.
         */

    }, {
        key: 'canPerformAction',
        value: function canPerformAction(action) {
            switch (action) {
                case 'cashier':
                    if (!this.showCashierButton) {
                        return false;
                    }
                    break;
                case 'history':
                    if (!this.showHistoryButton) {
                        return false;
                    }
                    break;
                case 'home':
                    if (!this.showHomeButton) {
                        return false;
                    }
                    break;
                case 'buy-more':
                    if (!this.showBuyMoreButton) {
                        return false;
                    }
                    break;
            }

            return true;
        }
    }]);

    return NotificationView;
}(PIXI.Container);

exports.default = NotificationView;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slider = __webpack_require__(13);

var _slider2 = _interopRequireDefault(_slider);

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Foreground visualization of the data that model contains.
 */
var SettingsView = function (_PIXI$Container) {
    _inherits(SettingsView, _PIXI$Container);

    function SettingsView(size, options) {
        _classCallCheck(this, SettingsView);

        var _this = _possibleConstructorReturn(this, (SettingsView.__proto__ || Object.getPrototypeOf(SettingsView)).call(this));

        _this.formWidth = 274;

        _this.isOpen = false;
        _this.isAnimating = false;
        _this.interactive = true;
        _this.interactiveChildren = false;
        _this.visible = false;

        _this.options = options;

        _this.changedSettingsHandler = options.onChange;
        _this.submitSettingsHandler = options.onSubmit;
        _this.onVisibilityChange = options.onVisibilityChange;

        _this.model = {
            stake: options.stake,
            autoplayRounds: 0,
            lossLimit: 0,
            singleWin: 0
        };

        _this.addBg(size);

        _this.inner = new PIXI.Container();
        // this.inner.position.set(size.stage.x, size.stage.y);
        _this.addChild(_this.inner);

        var square = new PIXI.Graphics();
        square.beginFill(0x000000);
        square.drawRect(0, 0, _this.formWidth, 300);
        square.endFill();
        _this.inner.addChild(square

        // Title
        );var titleStyle = {
            fontSize: 18,
            fontFamily: options.font,
            fill: 0xFFFFFF
        };

        var titletext = __t.str('Settings').toUpperCase();

        _this.title = new PIXI.Text(titletext, titleStyle);
        _this.inner.addChild(_this.title);
        _this.title.centerX(_this.formWidth);
        _this.title.y = 24;

        _this.addCloseButton(size.width, 10, function () {
            return _this.close();
        });

        // Sliders
        var defaultOpts = {
            endCapLeft: window.SUGA.Loader.makeTexturesFromName('slider-corner-left')[0],
            endCapRight: window.SUGA.Loader.makeTexturesFromName('slider-corner-right')[0],
            handleImg: window.SUGA.Loader.makeTexturesFromName('btn-slider-normal')[0],
            barImg: window.SUGA.Loader.makeTexturesFromName('slider-tint')[0],
            font: options.font,
            primaryColor: options.primaryColor
        };

        // stake
        var x = 0;
        var stakeStops = options.stakes;

        _this.addStakeSlider(defaultOpts, _this.model.stake, options.balance, stakeStops, x, 100, options.paytable);

        // has Autoplay?
        if (!options.autoplayRounds || !options.autoplayRounds.length) return _possibleConstructorReturn(_this);

        // Autoplay Subtitle
        var subtitleStyle = {
            fontSize: 14,
            fontFamily: options.font,
            fill: 0xFFFFFF
        };

        var subtitletext = __t.str('Autoplay').toUpperCase();

        _this.subtitle = new PIXI.Text(subtitletext, subtitleStyle);
        _this.inner.addChild(_this.subtitle);
        _this.subtitle.centerX(_this.formWidth);
        _this.subtitle.y = 180;

        // Autoplay
        var roundsStops = [0].concat(options.autoplayRounds);
        var lossLimitStops = calculateLossLimitStops(roundsStops[1], options.stake);
        var singleWinStops = calculateSingleWinStops(options.paytable, options.stake);

        _this.addAutoplayRoundsSlider(defaultOpts, _this.model.autoplayRounds, roundsStops, x, 240);
        _this.addLossLimitSlider(defaultOpts, _this.model.lossLimit, lossLimitStops, x, 306);
        _this.addSingleWinSlider(defaultOpts, _this.model.singleWin, singleWinStops, x, 372);

        var innerX = (size.width - _this.formWidth) / 2;
        _this.inner.x = innerX;
        return _this;
    }

    _createClass(SettingsView, [{
        key: 'resetModel',
        value: function resetModel() {
            this.model.autoplayRounds = 0;
            this.sliderRounds.slide(0);
            this.sliderLossLimit.disable();
            this.sliderSingleWin.disable();
        }
    }, {
        key: 'resize',
        value: function resize(size) {
            this.removeChild(this.bg);
            this.bg = null;
            this.addBg(size);

            this.closedY = size.viewportHeight;

            if (!this.isOpen) {
                this.y = this.closedY;
            }

            // if (this.inner)
            // {
            //     this.inner.position.set(size.stage.x, size.stage.y);
            // }

            this.closeButton.x = size.width - this.closeButton.width - this.closeButton.padding;
        }
    }, {
        key: 'addBg',
        value: function addBg(size) {
            this.bg = createBg(size.width, size.height);
            this.addChildAt(this.bg, 0);
        }
    }, {
        key: 'addCloseButton',
        value: function addCloseButton(viewWidth, padding, closeHandler) {
            var options = {
                normalUrl: window.SUGA.Loader.makeTexturesFromName('btn-close-normal')[0],
                hoverUrl: window.SUGA.Loader.makeTexturesFromName('btn-close-hover')[0],
                tapped: closeHandler,
                remainActive: true
            };

            this.closeButton = new _button2.default(options);
            this.addChild(this.closeButton);
            this.closeButton.x = viewWidth - this.closeButton.width - padding;
            this.closeButton.y = padding;
            this.closeButton.padding = padding;
        }
    }, {
        key: 'addStakeSlider',
        value: function addStakeSlider(options, stake, balance, stops, x, y, paytable) {
            var _this2 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Stake'), sliderOptions.stops = stops, sliderOptions.isCurrency = true, sliderOptions.value = stake, sliderOptions.hasOff = false, sliderOptions.maxValue = balance;
            sliderOptions.onChange = function (value) {
                return _this2.stakeChanged(value);
            };

            this.sliderStake = new _slider2.default(sliderOptions);
            this.sliderStake.position.set(x, y);
            this.inner.addChild(this.sliderStake);
        }
    }, {
        key: 'addAutoplayRoundsSlider',
        value: function addAutoplayRoundsSlider(options, value, stops, x, y) {
            var _this3 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Rounds');
            sliderOptions.stops = stops;
            sliderOptions.isCurrency = false;
            sliderOptions.value = value;
            sliderOptions.hasOff = true;
            sliderOptions.onChange = function (value) {
                return _this3.roundsChanged(value);
            };

            this.sliderRounds = new _slider2.default(sliderOptions);
            this.sliderRounds.position.set(x, y);
            this.inner.addChild(this.sliderRounds);
        }
    }, {
        key: 'addLossLimitSlider',
        value: function addLossLimitSlider(options, value, stops, x, y) {
            var _this4 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Loss limit');
            sliderOptions.stops = stops;
            sliderOptions.isCurrency = true;
            sliderOptions.value = value;
            sliderOptions.hasOff = true;
            sliderOptions.enabled = false;
            sliderOptions.onChange = function (value) {
                return _this4.lossLimitChanged(value);
            };

            this.sliderLossLimit = new _slider2.default(sliderOptions);
            this.sliderLossLimit.position.set(x, y);
            this.inner.addChild(this.sliderLossLimit);
        }
    }, {
        key: 'addSingleWinSlider',
        value: function addSingleWinSlider(options, value, stops, x, y) {
            var _this5 = this;

            var sliderOptions = Object.assign({}, options);

            sliderOptions.title = __t.str('Stop on single win');
            sliderOptions.stops = stops;
            sliderOptions.isCurrency = true;
            sliderOptions.value = value;
            sliderOptions.hasOff = true;
            sliderOptions.enabled = false;
            sliderOptions.onChange = function (value) {
                return _this5.singleWinChanged(value);
            };

            this.sliderSingleWin = new _slider2.default(sliderOptions);
            this.sliderSingleWin.position.set(x, y);
            this.inner.addChild(this.sliderSingleWin);

            this.sliderSingleWin.name = 'sliderSingleWin';
        }
    }, {
        key: 'stakeChanged',
        value: function stakeChanged(stake) {
            this.model.stake = stake;

            if (this.sliderRounds && this.sliderRounds.value > 0) {
                this.changeLossLimit();
            }

            if (this.sliderSingleWin) {
                this.changeSingleWin();
            }

            this.changedSettingsHandler(this.model);
        }
    }, {
        key: 'roundsChanged',
        value: function roundsChanged(rounds) {
            this.model.autoplayRounds = rounds;

            if (rounds > 0) {
                this.sliderLossLimit.enable();
                this.sliderSingleWin.enable();
                this.changeLossLimit();
            } else {
                this.sliderLossLimit.disable();
                this.sliderSingleWin.disable();
            }

            this.validate();
        }
    }, {
        key: 'lossLimitChanged',
        value: function lossLimitChanged(lossLimit) {
            this.model.lossLimit = lossLimit;
            this.validate();
        }
    }, {
        key: 'singleWinChanged',
        value: function singleWinChanged(singleWin) {
            this.model.singleWin = singleWin;
        }
    }, {
        key: 'changeLossLimit',
        value: function changeLossLimit() {
            var isUK = this.options.ukRegulations;
            var stake = this.model.stake;
            var rounds = this.model.autoplayRounds;
            var lossLimit = this.model.lossLimit;
            var sliderLossStops = calculateLossLimitStops(rounds, stake);
            var newLossLimit = getClosestLowerValue(sliderLossStops, this.model.lossLimit);

            this.sliderLossLimit.setStops(sliderLossStops, newLossLimit);
            this.model.lossLimit = newLossLimit;
        }
    }, {
        key: 'changeSingleWin',
        value: function changeSingleWin() {
            var singleWinStops = calculateSingleWinStops(this.options.paytable, this.model.stake);
            var newSingleWin = getClosestLowerValue(singleWinStops, this.model.singleWin);

            this.sliderSingleWin.setStops(singleWinStops, newSingleWin);
            this.model.singleWin = newSingleWin;
        }
    }, {
        key: 'validate',
        value: function validate() {
            var isUK = this.options.ukRegulations;
            var lossLimit = this.model.lossLimit;
            var rounds = this.model.autoplayRounds;

            if (isUK && rounds > 0 && lossLimit <= 0) {
                this.closeButton.disable();
                this.sliderLossLimit.showError();
            } else {
                this.closeButton.enable();
                this.sliderLossLimit.hideError();
            }
        }
    }, {
        key: 'open',
        value: function open(options) {
            var _this6 = this;

            if (this.isAnimating) return;

            this.isAnimating = true;
            this.visible = true;

            var ease = window.CustomEase.create('custom', 'M0,0,C0,0,0.714,1,0.714,1,0.714,1,0.734,0.948,0.858,0.948,0.966,0.948,1,1,1,1');

            this.onVisibilityChange(true);

            TweenMax.to(this, 0.6, { y: 0, ease: ease, onComplete: function onComplete() {
                    _this6.isOpen = true;
                    _this6.isAnimating = false;
                    _this6.interactiveChildren = true;
                } });
        }
    }, {
        key: 'close',
        value: function close() {
            var _this7 = this;

            if (this.isAnimating) return;
            if (!this.closeButton.isEnabled) return;

            this.isAnimating = true;

            this.onVisibilityChange(false);

            TweenMax.to(this, 0.3, { y: this.closedY, onComplete: function onComplete() {
                    _this7.isOpen = false;
                    _this7.isAnimating = false;
                    _this7.interactiveChildren = false;
                    _this7.visible = false;

                    _this7.submitSettingsHandler(_this7.model);
                } });
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: 'pointerdown',
        value: function pointerdown(e) {
            e.stopPropagation();
        }
    }, {
        key: 'pointerup',
        value: function pointerup(e) {
            e.stopPropagation();
        }
    }, {
        key: 'pointermove',
        value: function pointermove(e) {
            e.stopPropagation();
        }
    }]);

    return SettingsView;
}(PIXI.Container);

exports.default = SettingsView;


function createBg(w, h) {
    var bg = new PIXI.Graphics();

    bg.beginFill(0x000000, 0.9);
    bg.drawRect(0, 0, w, h);
    bg.endFill();

    return bg;
}

function calculateLossLimitStops(amount, stopSize) {
    amount += 1;

    return Array(amount).fill(0).map(function (i, j) {
        return Math.round(j * stopSize * 100) / 100;
    });
}

function calculateSingleWinStops(paytable, stake) {
    var array = [0].concat(paytable);

    return array.map(function (item) {
        return item * stake;
    });
}

function getClosestLowerValue(array, value) {
    var res = array[array.length - 1];
    var i = array.length - 1;

    while (i >= 0) {
        if (array[i] <= value) {
            res = array[i];
            break;
        }
        i -= 1;
    }

    return res;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SettingsView = exports.NotificationView = exports.MenuView = exports.HelpView = exports.BottomBarView = exports.Button = exports.Pixi = exports.Canvas = undefined;

var _canvas = __webpack_require__(1);

var _canvas2 = _interopRequireDefault(_canvas);

var _pixiExtend = __webpack_require__(2);

var Pixi = _interopRequireWildcard(_pixiExtend);

var _button = __webpack_require__(0);

var _button2 = _interopRequireDefault(_button);

var _bottomBarView = __webpack_require__(3);

var _bottomBarView2 = _interopRequireDefault(_bottomBarView);

var _helpView = __webpack_require__(4);

var _helpView2 = _interopRequireDefault(_helpView);

var _menuView = __webpack_require__(5);

var _menuView2 = _interopRequireDefault(_menuView);

var _notificationView = __webpack_require__(6);

var _notificationView2 = _interopRequireDefault(_notificationView);

var _settingsView = __webpack_require__(7);

var _settingsView2 = _interopRequireDefault(_settingsView);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Canvas = _canvas2.default;
exports.Pixi = Pixi;
exports.Button = _button2.default;
exports.BottomBarView = _bottomBarView2.default;
exports.HelpView = _helpView2.default;
exports.MenuView = _menuView2.default;
exports.NotificationView = _notificationView2.default;
exports.SettingsView = _settingsView2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bottom bar visualization of the data that model contains.
 */
var AutoplayBar = function (_PIXI$Container) {
    _inherits(AutoplayBar, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  gameModel        The game model
     * @param  {CurrencyManager}  currencyManager  The currency manager
     */
    function AutoplayBar(options) {
        _classCallCheck(this, AutoplayBar);

        var _this = _possibleConstructorReturn(this, (AutoplayBar.__proto__ || Object.getPrototypeOf(AutoplayBar)).call(this));

        _this.addBg(options);

        _this.options = options;

        _this.visible = false;
        _this.isOpen = false;

        _this.yTextOffset = 4;
        return _this;
    }

    /**
     * Adds a background.
     */


    _createClass(AutoplayBar, [{
        key: 'addBg',
        value: function addBg(options) {
            this.bg = new PIXI.Graphics();
            this.bg.beginFill(options.primaryColor);
            this.bg.drawRect(0, 0, options.width, options.height);
            this.bg.endFill();
            // this.bg.alpha = 0.9;
            this.addChildAt(this.bg, 0);
        }
    }, {
        key: 'updateAutoplay',
        value: function updateAutoplay(round, rounds) {
            if (rounds <= 0) {
                this.close();

                return;
            }

            this.open();

            var label = round + '/' + rounds;

            if (!this.autoplayTitle) {
                var titleStyle = {
                    fill: 0x000000,
                    fontSize: 12,
                    fontFamily: this.options.font
                };
                var titleText = __t.str('Autoplay').toUpperCase();

                this.autoplayTitle = new PIXI.Text(titleText, titleStyle);
                this.addChild(this.autoplayTitle);
                this.autoplayTitle.position.set(10, this.yTextOffset);

                var countStyle = {
                    fill: 0xFFFFFF,
                    fontSize: 12,
                    fontFamily: this.options.font
                };

                this.autoplayCount = new PIXI.Text(label, countStyle);
                this.addChild(this.autoplayCount);
            } else {
                this.autoplayCount.text = label;
            }

            var x = this.autoplayTitle.x + this.autoplayTitle.width + 5;

            this.autoplayCount.position.set(x, this.yTextOffset);
        }
    }, {
        key: 'autoplayClearReason',
        value: function autoplayClearReason() {
            if (this.autoplayReason) {
                this.autoplayReason.text = '';
            }
        }
    }, {
        key: 'autoplayStopped',
        value: function autoplayStopped(reason) {
            reason = reason.toUpperCase();

            if (!this.autoplayReason) {
                var style = {
                    fill: 0x000000,
                    fontSize: 12,
                    fontFamily: this.options.font
                };

                this.autoplayReason = new PIXI.Text(reason, style);
                this.addChild(this.autoplayReason);
            } else {
                this.autoplayReason.text = reason;
            }

            var x = this.options.width - this.autoplayReason.width - 5;

            this.autoplayReason.position.set(x, this.yTextOffset);
        }
    }, {
        key: 'open',
        value: function open() {
            var _this2 = this;

            if (this.isAnimating || this.isOpen) return;

            this.autoplayClearReason();

            this.visible = true;

            window.TweenMax.to(this, 0.2, { y: -21, onComplete: function onComplete() {
                    _this2.isOpen = true;
                    _this2.interactiveChildren = true;
                } });
        }
    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            if (this.isAnimating) return;

            window.TweenMax.to(this, 0.1, { y: 0, onComplete: function onComplete() {
                    _this3.isOpen = false;
                    _this3.visible = false;
                } });
        }
    }, {
        key: 'resize',
        value: function resize(width) {
            this.options.width = width;
            this.bg.removeSelf();
            this.addBg(this.options);

            if (this.autoplayReason) {
                this.autoplayReason.x = this.options.width - this.autoplayReason.width - 5;
            }
        }
    }]);

    return AutoplayBar;
}(PIXI.Container);

exports.default = AutoplayBar;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for base menu button.
 */
var Button = function (_PIXI$Container) {
    _inherits(Button, _PIXI$Container);

    /**
     * Constructs the object.
     *
     * @param  {Object}  options  The options
     */
    function Button(options) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

        _this.options = options;

        _this.tag = 'button';

        _this.isEnabled = true;
        _this.interactive = true;
        _this.buttonMode = true;

        _this.action = null;
        _this.remainActive = true;

        _this.enable();
        _this.removeChildren();

        _this.normalBg = new PIXI.Sprite(options.buttonImage);

        _this.bg = new PIXI.Graphics();
        _this.bg.beginFill(options.tint, 0.1);
        _this.bg.drawRect(0, 0, _this.normalBg.width, _this.normalBg.height);
        _this.bg.endFill();
        _this.bg.visible = false;

        _this.addChild(_this.bg);
        _this.addChild(_this.normalBg);

        if (typeof options.toggleState === 'boolean') {
            if (options.toggleState) {
                _this.setOn();
            } else {
                _this.setOff();
            }
        }
        return _this;
    }

    /**
     * Pixi Pointer event
     *
     * @param  {UIEvent}  e  The event
     */


    _createClass(Button, [{
        key: 'pointerdown',
        value: function pointerdown(e) {
            if (!this.isEnabled) {
                return;
            }

            e.stopPropagation();

            this.normalBg.tint = this.options.tint;
        }

        /**
         * Pixi Pointer event
         */

    }, {
        key: 'pointerover',
        value: function pointerover() {
            if (!this.isEnabled) {
                return;
            }

            if (this.hovered) {
                this.hovered();
            }

            this.normalBg.tint = this.options.tint;
            this.bg.visible = true;
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerup',
        value: function pointerup(e) {
            if (!this.isEnabled) {
                return;
            }

            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointertap',
        value: function pointertap(e) {
            if (!this.isEnabled) {
                return;
            }
            e.stopPropagation();
            this.reset();

            this._tapped(e);
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerout',
        value: function pointerout() {
            this.reset();
        }

        /**
         * Pixi Pointer event
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: 'pointerupoutside',
        value: function pointerupoutside() {
            this.reset();
        }

        /**
         * Reset
         */

    }, {
        key: 'reset',
        value: function reset() {
            if (this.normalBg) {
                this.normalBg.tint = 0xFFFFFF;
                this.bg.visible = false;
            }
        }

        /**
         * Enable
         */

    }, {
        key: 'enable',
        value: function enable() {
            this.reset();
            this.interactive = true;
            this.buttonMode = true;
            this.alpha = 1;

            this.isEnabled = true;
        }

        /**
         * Disable
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.reset();
            this.interactive = false;
            this.buttonMode = false;
            this.alpha = 0.5;

            this.isEnabled = false;
        }

        /**
         * @private
         * Button pressed action
         *
         * @param  {UIEvent}  e  The event
         */

    }, {
        key: '_tapped',
        value: function _tapped(e) {
            if (this.tapped) {
                this.tapped(e);
            } else {
                throw new Error('Button has no Action');
            }

            if (!this.remainActive) {
                this.disable();
            }
        }

        /**
         * Turn Button on
         */

    }, {
        key: 'setOn',
        value: function setOn() {
            this.state = true;

            this.normalBg.texture = this.options.buttonImage;
        }

        /**
         * Turn button off
         */

    }, {
        key: 'setOff',
        value: function setOff() {
            this.state = false;

            this.normalBg.texture = this.options.buttonOffImage;
        }

        /**
         * Toggle state
         *
         * @return {Boolean}  True if on false if off
         */

    }, {
        key: 'toggleState',
        value: function toggleState() {
            if (this.state) {
                this.setOff();
            } else {
                this.setOn();
            }

            return this.state;
        }
    }]);

    return Button;
}(PIXI.Container);

exports.default = Button;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = __webpack_require__(10);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonContainer = function (_PIXI$Container) {
    _inherits(ButtonContainer, _PIXI$Container);

    function ButtonContainer(options) {
        _classCallCheck(this, ButtonContainer);

        var _this = _possibleConstructorReturn(this, (ButtonContainer.__proto__ || Object.getPrototypeOf(ButtonContainer)).call(this));

        Object.assign(_this, options);

        _this.buttonYOffset = 0;

        var color = options.primaryColor;
        var mute = options.mute;

        var x = 0;

        if (_this.showHomeButton) {
            _this.addHomeButton(x, color);
            _this.addLine(x);
            x += 45;
        }

        _this.addSoundButton(x, color, mute);
        _this.addLine(x);
        x += 45;

        if (_this.showHelpButton) {
            _this.addHelpButton(x, color);
            _this.addLine(x);
            x += 45;
        }

        if (!_this.isBasketMode && _this.settingsButtonHandler) {
            _this.addSettingsButton(x, color);
            _this.addLine(x);
        }

        if (options.fullscreenEnabled) {
            _this.addFullscreenButton(x, color, false);
            _this.addLine(x);
        }
        return _this;
    }

    /**
     * Adds a line.
     *
     * @param  {Number}  x  The x position
     */


    _createClass(ButtonContainer, [{
        key: 'addLine',
        value: function addLine(x) {
            x = x + 45;
            var graphics = new PIXI.Graphics();

            graphics.lineStyle(1, 0xffffff);
            graphics.moveTo(x, 0);
            graphics.lineTo(x, 45);
            graphics.endFill();
            graphics.alpha = 0.1;
            graphics.cachedAsBitmap = true;
            this.addChild(graphics);
        }

        /**
         * Adds a home button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addHomeButton',
        value: function addHomeButton(x, color) {
            var _this2 = this;

            var options = {
                tint: color,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-home-normal')[0]
            };

            this.homeButton = new _button2.default(options);
            this.homeButton.tapped = function (e) {
                return _this2.homeButtonClick(e);
            };
            this.homeButton.position.set(x, this.buttonYOffset);
            this.addChild(this.homeButton);
        }

        /**
         * Home button clicked
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'homeButtonClick',
        value: function homeButtonClick(e) {
            window.SUGA.Sound.play('click');
            this.homeButtonHandler(e);
            e.stopPropagation();
        }

        /**
         * Adds a help button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addHelpButton',
        value: function addHelpButton(x, color) {
            var _this3 = this;

            var options = {
                tint: color,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-help-normal')[0]
            };

            this.helpButton = new _button2.default(options);
            this.helpButton.tapped = function (e) {
                return _this3.helpButtonClick(e);
            };
            this.helpButton.position.set(x, this.buttonYOffset);

            this.addChild(this.helpButton);
        }

        /**
         * Help button clicked
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'helpButtonClick',
        value: function helpButtonClick(e) {
            window.SUGA.Sound.play('click');
            this.helpButtonHandler(e);
            e.stopPropagation();
        }

        /**
         * Adds a help button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addSettingsButton',
        value: function addSettingsButton(x, color) {
            var _this4 = this;

            var options = {
                tint: color,
                toggleBtn: true,
                toggleState: false,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-settings-active')[0],
                buttonOffImage: window.SUGA.Loader.makeTexturesFromName('btn-settings-normal')[0]
            };

            this.settingsButton = new _button2.default(options);
            this.settingsButton.tapped = function (e) {
                return _this4.settingsButtonClick(e);
            };
            this.settingsButton.position.set(x, this.buttonYOffset);

            this.addChild(this.settingsButton);
        }

        /**
         * Help button clicked
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'settingsButtonClick',
        value: function settingsButtonClick(e) {
            window.SUGA.Sound.play('click');
            e.stopPropagation();

            this.settingsButtonHandler(e);
        }
    }, {
        key: 'toggleSettings',
        value: function toggleSettings(isOpen) {
            if (isOpen) {
                this.settingsButton.setOn();
            } else {
                this.settingsButton.setOff();
            }
        }

        /**
         * Adds a sound button.
         *
         * @param  {Number}  x  The x position
         */

    }, {
        key: 'addSoundButton',
        value: function addSoundButton(x, color, mute) {
            var _this5 = this;

            var options = {
                tint: color,
                toggleBtn: true,
                toggleState: !mute,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-soundon-normal')[0],
                buttonOffImage: window.SUGA.Loader.makeTexturesFromName('btn-soundoff-normal')[0]
            };

            this.soundButton = new _button2.default(options);
            this.soundButton.position.set(x, this.buttonYOffset);
            this.addChild(this.soundButton);

            // Hack to always hide sound

            this.soundButton.tapped = function (e) {
                _this5.toggleSoundClick(e);
            };
        }

        /**
         * Toggle sound button
         *
         * @param  {UIEvent}  e  event
         */

    }, {
        key: 'toggleSoundClick',
        value: function toggleSoundClick(e) {
            e.stopPropagation();

            window.SUGA.Sound.play('click');

            this.soundButton.toggleState();

            this.muteButtonHandler(e);
        }

        /**
         * Display the sound on button
         */

    }, {
        key: 'displaySoundOnButton',
        value: function displaySoundOnButton() {
            this.soundButton.setOn();
        }

        /**
         * Display the Sound off button
         */

    }, {
        key: 'displaySoundOffButton',
        value: function displaySoundOffButton() {
            this.soundButton.setOff();
        }
    }, {
        key: 'addFullscreenButton',
        value: function addFullscreenButton(x, color, fullscreen) {
            var _this6 = this;

            var options = {
                tint: color,
                toggleBtn: true,
                toggleState: fullscreen,
                buttonImage: window.SUGA.Loader.makeTexturesFromName('btn-fullscreen-active')[0],
                buttonOffImage: window.SUGA.Loader.makeTexturesFromName('btn-fullscreen-normal')[0]
            };

            this.fullscreenBtn = new _button2.default(options);
            this.fullscreenBtn.tapped = function (e) {
                return _this6.fullscreenClick(e);
            };
            this.fullscreenBtn.position.set(x, this.buttonYOffset);

            this.addChild(this.fullscreenBtn);
        }
    }, {
        key: 'fullscreenClick',
        value: function fullscreenClick(e) {
            e.stopPropagation();

            window.SUGA.Sound.play('click');

            this.fullscreenBtn.toggleState();

            this.fullscreenButtonHandler(e);
        }
    }, {
        key: 'enableNavigationButtons',
        value: function enableNavigationButtons() {
            // listen when to enable/disable
            if (this.helpButton) {
                this.helpButton.enable();
            }
            // listen when to enable/disable
            if (this.settingsButton) {
                this.settingsButton.enable();
            }
        }

        /**
         * Disables the navigation buttons.
         */

    }, {
        key: 'disableNavigationButtons',
        value: function disableNavigationButtons() {
            // listen when to enable/disable
            if (this.helpButton) {
                this.helpButton.disable();
            }
            // listen when to enable/disable
            if (this.settingsButton) {
                this.settingsButton.disable();
            }
        }
    }]);

    return ButtonContainer;
}(PIXI.Container);

exports.default = ButtonContainer;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bottom bar visualization of the data that model contains.
 */
var Counter = function (_PIXI$Text) {
    _inherits(Counter, _PIXI$Text);

    /**
     * Constructs the object.
     *
     * @param  {Object}  gameModel        The game model
     * @param  {CurrencyManager}  currencyManager  The currency manager
     */
    function Counter(initCount, style, formatter, currencyMulitplier, maxPrize) {
        _classCallCheck(this, Counter);

        var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this, initCount, style));

        _this.counterTween = null;
        _this.formatter = formatter;
        _this.currencyMulitplier = currencyMulitplier;
        _this.maxPrize = maxPrize;

        return _this;
    }

    /**
     * Finish count animation instantly
     */


    _createClass(Counter, [{
        key: 'instantFinish',
        value: function instantFinish() {
            // end current counter
            if (this.counterTween) {
                this.counterTween.totalProgress(1).kill();
            }
        }

        /**
         * { function_description }
         *
         * @param  {Number}    newCount  The new count
         * @param  {Function}  cb          { parameter_description }
         */

    }, {
        key: 'updateCount',
        value: function updateCount(newCount, cb) {
            var _this2 = this;

            this.instantFinish();

            var animate = true;

            if ((typeof newCount === 'undefined' ? 'undefined' : _typeof(newCount)) === 'object') {
                var _newCount = newCount;
                animate = _newCount.animate;

                newCount = newCount.count;
            }

            // if this is a debit or we are getting initial count
            if (this.currentCount >= newCount || this.currentCount < 0 || !animate) {
                this.setCount(newCount);
                this.centerCount();

                return;
            }

            if (!this.currentCount) {
                this.currentCount = 0;
            }

            var diff = newCount - this.currentCount;

            diff = Math.ceil(diff / this.currencyMulitplier);
            var maxPrize = this.maxPrize / this.currencyMulitplier;

            // max & min seconds
            var min = 2;
            var max = 15 - min;
            var scale = max / Math.log10(maxPrize);
            var timeLength = Math.log(diff) * Math.LOG10E * scale + min;
            var frames = timeLength * 60;
            var steps = Math.floor(frames / 2);

            var obj = {
                count: this.currentCount
            };

            var to = {
                ease: window.SteppedEase.config(steps),
                count: newCount,
                onUpdate: function onUpdate() {
                    _this2.setCount(obj.count);
                },
                // play sound here

                onComplete: function onComplete() {
                    _this2.setCount(obj.count);
                    _this2.counterTween = null;
                    // soundManager.play 'coin-done'
                    if (cb) {
                        cb();
                    }
                }
            };

            this.counterTween = window.TweenMax.to(obj, timeLength, to);
        }

        /**
         * Sets the count.
         *
         * @param  {(number|string)}  amount  The amount
         * @return {boolean}          { description_of_the_return_value }
         */

    }, {
        key: 'setCount',
        value: function setCount(amount) {
            if (this.currentCount === amount) {
                return false;
            }

            this.currentCount = amount;

            amount = this.formatter(amount);

            var newLength = amount.length;
            var oldLength = this.text.length;

            this.text = amount;
            this.centerCount();

            return true;
        }

        /**
         * Center's the count label
         */

    }, {
        key: 'centerCount',
        value: function centerCount() {
            this.centerX();
        }
    }]);

    return Counter;
}(PIXI.Text);

exports.default = Counter;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for base menu button.
 */
var Slider = function (_PIXI$Container) {
    _inherits(Slider, _PIXI$Container);

    function Slider(options) {
        _classCallCheck(this, Slider);

        var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this));

        var defaults = {
            enabled: true
        };

        options.barHeight = 6;
        options.barWidth = 274;
        options.handleRadius = options.handleImg.width / 2;
        options.animationSpeed = 0.2;

        _this.options = Object.assign({}, options, defaults);
        _this.value = _this.options.value;
        _this.isDragging = false;
        _this.barY = 10;

        // background bar
        // this.backgroundBar = new PIXI.Sprite(options.barBg)
        _this.backgroundBar = new PIXI.Sprite(options.barImg);
        _this.backgroundBar.width = options.barWidth;
        _this.backgroundBar.tint = 0x737373;
        _this.backgroundBar.position.y = _this.barY;
        _this.backgroundBar.interactive = true;
        _this.backgroundBar.buttonMode = true;
        _this.backgroundBar.pointerup = function (e) {
            return _this.click(e);
        };
        _this.addChild(_this.backgroundBar);

        // the colored endcap
        _this.endCapLeft = new PIXI.Sprite(options.endCapLeft);
        _this.endCapLeft.tint = options.primaryColor;
        _this.endCapLeft.x = -_this.endCapLeft.width;
        _this.endCapLeft.y = _this.barY;
        _this.addChild(_this.endCapLeft);

        _this.endCapRight = new PIXI.Sprite(options.endCapRight);
        _this.endCapRight.tint = 0x737373;
        _this.endCapRight.x = options.barWidth;
        _this.endCapRight.y = _this.barY;
        _this.addChild(_this.endCapRight);

        // the colored bar
        _this.highlightBar = new PIXI.Sprite(options.barImg);
        _this.highlightBar.y = _this.barY;
        _this.addChild(_this.highlightBar);

        // handle
        _this.handle = drawHandle(_this.barY + options.barHeight / 2, options.handleImg, function () {
            return _this.down();
        }, function (x) {
            return _this.slide(x);
        }, function (x) {
            return _this.snap(_this.value, true);
        });

        // slider title
        var style = {
            fontFamily: options.font,
            fill: 0xFFFFFF,
            fontSize: 14
        };

        _this.label = new PIXI.Text(options.title, style);
        _this.label.x = (options.barWidth - _this.label.width) / 2;
        _this.label.y = 20;

        // moving value
        var valueStyle = {
            fontFamily: options.font,
            fill: options.primaryColor,
            fontSize: 12
        };

        _this.valueLabel = new PIXI.Text('' + options.value, valueStyle);
        _this.valueLabel.y = _this.barY - 28;
        _this.valueLabel.defaultY = _this.barY - 28;
        _this.valueLabel.genieY = _this.barY - 55;
        _this.valueLabel.anchor.x = 0.5;

        // left & right labels
        _this.stopStyle = {
            fontFamily: options.font,
            fontWeigth: 100,
            fill: 0x737373,
            fontSize: 10
        };

        _this.stops = _this.addStops(options.stops, _this.stopStyle, options.barWidth, _this.barY);
        _this.marks = _this.addMarks(options.stops, options.barWidth, options.barHeight, _this.barY);
        _this.addChild(_this.label);
        _this.addChild(_this.handle);
        _this.addChild(_this.valueLabel);

        var x = calculateStepPosition(_this.value, options.barWidth, options.stops, options.maxValue);

        _this.slide(x);

        if (options.enabled === false) {
            _this.disable();
        } else {
            _this.enable();
        }
        return _this;
    }

    _createClass(Slider, [{
        key: 'down',
        value: function down() {
            genieGrow(this.valueLabel, this.options.animationSpeed);
        }
    }, {
        key: 'slide',
        value: function slide(x) {
            this.hideError();

            var pos = x - this.worldTransform.tx;

            if (pos < 0) {
                pos = 0;
            } else if (pos > this.options.barWidth) {
                pos = this.options.barWidth;
            }

            var value = void 0;

            value = calculateStepValue(pos, this.options.barWidth, this.options.stops, this.options.maxValue);

            this.handle.x = pos;
            this.highlightBar.width = pos;

            this.setValue(value);
            this.valueLabel.x = pos; // - (this.valueLabel.width/2)

            return value;
        }
    }, {
        key: 'snap',
        value: function snap(value, shouldGenie) {
            var pos = calculateStepPosition(value, this.options.barWidth, this.options.stops, this.options.maxValue);
            var labelPos = pos;

            window.TweenMax.to(this.handle, 0.2, { x: pos });
            window.TweenMax.to(this.valueLabel, 0.2, { x: labelPos });
            window.TweenMax.to(this.highlightBar, 0.2, { width: pos }); // minus semi circle endcap

            this.options.onChange(value);

            if (shouldGenie) {
                genieShrink(this.valueLabel, this.options.animationSpeed);
            }
        }
    }, {
        key: 'addStops',
        value: function addStops(stops, style, w, y) {
            y -= 12;
            var firstVal = formatValue(stops[0], this.options.isCurrency, this.options.hasOff);
            var lastVal = formatValue(stops[stops.length - 1], this.options.isCurrency, this.options.hasOff);
            var first = new PIXI.Text(firstVal, style);

            first.y = y;
            var last = new PIXI.Text(lastVal, style);

            last.y = y;
            last.x = w - last.width;
            this.addChild(first);
            this.addChild(last);

            return [first, last];
        }
    }, {
        key: 'removeStops',
        value: function removeStops(stops) {
            stops.map(function (item) {
                item.removeSelf();
            });

            return [];
        }
    }, {
        key: 'addMarks',
        value: function addMarks(stops, width, height, y) {
            var marks = [];
            var total = width;
            var stopSize = total / (stops.length - 1);
            var i = 1;

            while (i < stops.length - 1) {
                var x = stopSize * i;
                var line = drawRect(x, y, 1, height, 0x000000);

                this.addChild(line);
                marks.push(line);
                i++;
            }

            return marks;
        }
    }, {
        key: 'removeMarks',
        value: function removeMarks(marks) {
            marks.map(function (item) {
                item.removeSelf();
            });

            return [];
        }
    }, {
        key: 'setStops',
        value: function setStops(stops, value) {
            this.options.stops = stops;
            this.stops = this.removeStops(this.stops);
            this.marks = this.removeMarks(this.marks);
            this.stops = this.addStops(stops, this.stopStyle, this.options.barWidth, this.barY);
            this.marks = this.addMarks(stops, this.options.barWidth, this.options.barHeight, this.barY);
            this.handle.bringToFront();
            this.valueLabel.bringToFront();

            if (value !== undefined) {
                this.setValue(value);
            }

            this.snap(this.value, false);
        }
    }, {
        key: 'setValue',
        value: function setValue(value) {
            this.value = value;
            this.valueLabel.text = formatValue(value, this.options.isCurrency, this.options.hasOff);
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.interactiveChildren = true;
            this.backgroundBar.tint = 0x737373;
            this.highlightBar.tint = this.options.primaryColor;
            this.endCapLeft.tint = this.options.primaryColor;
            this.endCapRight.tint = 0x737373;
            this.handle.tint = 0xFFFFFF;
            this.stops[0].alpha = 1;
            this.stops[1].alpha = 1;
            this.label.alpha = 1;
            this.valueLabel.alpha = 1;
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.interactiveChildren = false;

            this.backgroundBar.tint = 0x333333;
            this.endCapRight.tint = 0x333333;

            this.highlightBar.tint = 0x555555;
            this.endCapLeft.tint = 0x555555;
            this.handle.tint = 0x555555;

            this.stops[0].alpha = 0.4;
            this.stops[1].alpha = 0.4;
            this.label.alpha = 0.4;
            this.valueLabel.alpha = 0.4;
        }
    }, {
        key: 'showError',
        value: function showError() {
            this.label.style.fill = 0xCE0020;
            this.valueLabel.style.fill = 0xCE0020;
        }
    }, {
        key: 'hideError',
        value: function hideError() {
            this.label.style.fill = 0xFFFFFF;
            this.valueLabel.style.fill = this.options.primaryColor;
        }
    }, {
        key: 'click',
        value: function click(e) {
            e.stopPropagation();
            var pos = e.data.global.x - this.worldTransform.tx;
            var value = calculateStepValue(pos, this.options.barWidth, this.options.stops);

            this.setValue(value);
            this.snap(value, false);
        }
    }]);

    return Slider;
}(PIXI.Container);

exports.default = Slider;


function formatValue(value, isCurrency, hasOff) {
    if (value == 0 && hasOff) return __t.str('Off');
    value = isCurrency ? __c.localize(value, true, false) : '' + Math.round(value);

    return value;
}

function calculateStepValue(x, total, stops, max) {
    var stopSize = total / (stops.length - 1);
    var index = Math.round(x / stopSize);
    var result = stops[index];

    if (max && result > max) {
        result = findNextLowestStopFromValue(max, stops);
    }

    return result;
}

function findNextLowestStopFromValue(val, stops) {
    var i = 0;

    while (i < stops.length) {
        if (val <= stops[i]) {
            return stops[i - 1];
        }
        i++;
    }

    return stops[stops.length - 1];
}

function calculateStepPosition(val, total, stops, max) {
    var i = 0;

    if (max && val > max) {
        val = findNextLowestStopFromValue(max, stops);
    }

    while (i < stops.length) {
        if (val <= stops[i]) {
            break;
        }
        i++;
    }
    var stopSize = total / (stops.length - 1);
    var result = stopSize * i;

    return result;
}

function drawHandle(y, texture, down, move, done) {
    var r = texture.width / 2;

    y -= r;
    var handle = new PIXI.Sprite(texture);

    handle.position.set(0, y);
    handle.anchor.set(0.5, 0);
    handle.interactive = true;
    handle.buttonMode = true;
    // handle.alpha = 0.5

    handle.pointerdown = function (e) {
        e.stopPropagation();
        this.isDragging = true;
        down();
    };

    handle.pointerup = function (e) {
        // e.stopPropagation()
        this.isDragging = false;
        done();
    };

    handle.pointerupoutside = function () {
        this.isDragging = false;
        done();
    };

    handle.pointermove = function (e) {
        if (!this.isDragging) return;
        move(e.data.global.x);
    };
    // const handle = new PIXI.Sprite.fromImage(img);
    // handle.position.set(x,y);
    return handle;
}

/**
 * Draws a rectangle.
 *
 * @param  {Number}  x      x coordinate
 * @param  {Number}  y      y coordinate
 * @param  {Number}  w      width
 * @param  {Number}  h      height
 * @param  {Number}  color  The color
 * @return {PIXI}    Rectangle
 */
function drawRect(x, y, w, h, color) {
    var bar = new PIXI.Graphics();

    bar.beginFill(0xFFFFFF);
    bar.drawRect(0, 0, w, h);
    bar.endFill();
    bar.position.set(x, y);
    bar.tint = color;

    return bar;
}

/**
 * Round number to neareset factor of N
 *
 * @param  {Number}  num  The number
 * @param  {Number}  by   the number to round to (e.g. nearest factor of 5)
 * @return {Number}  Rounded number
 */
function round(num, by) {
    if (num < by) return num;

    return Math.ceil(num / by) * by;
}

/**
 * Grow with genie effect
 *
 * @param  {PIXI.Text}  value  The value
 * @param  {Number}     speed  The speed
 */
function genieGrow(value, speed) {
    genie(value, 20, value.genieY, speed);
}

/**
 * Shrink with genie effect
 *
 * @param  {PIXI.Text}  value  The value
 * @param  {Number}     speed  The speed
 */
function genieShrink(value, speed) {
    genie(value, 12, value.defaultY, speed);
}

/**
 * Grow current value like a genie
 *
 * @param  {PIXI.Text}  value     The value
 * @param  {Number}     fontSize  The font size
 * @param  {Number}     y         { parameter_description }
 * @param  {Number}     speed     The speed
 */
function genie(value, fontSize, y, speed) {
    var style = {
        fontSize: fontSize
    };

    window.TweenMax.to(value.style, speed, style, speed);

    var position = {
        y: y,
        onUpdate: function onUpdate() {
            return value.clarify();
        }
    };

    window.TweenMax.to(value, speed, position);
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// stats.js - http://github.com/mrdoob/stats.js
(function(f,e){ true?module.exports=e():"function"===typeof define&&define.amd?define(e):f.Stats=e()})(this,function(){var f=function(){function e(a){c.appendChild(a.dom);return a}function u(a){for(var d=0;d<c.children.length;d++)c.children[d].style.display=d===a?"block":"none";l=a}var l=0,c=document.createElement("div");c.style.cssText="position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";c.addEventListener("click",function(a){a.preventDefault();
u(++l%c.children.length)},!1);var k=(performance||Date).now(),g=k,a=0,r=e(new f.Panel("FPS","#0ff","#002")),h=e(new f.Panel("MS","#0f0","#020"));if(self.performance&&self.performance.memory)var t=e(new f.Panel("MB","#f08","#201"));u(0);return{REVISION:16,dom:c,addPanel:e,showPanel:u,begin:function(){k=(performance||Date).now()},end:function(){a++;var c=(performance||Date).now();h.update(c-k,200);if(c>g+1E3&&(r.update(1E3*a/(c-g),100),g=c,a=0,t)){var d=performance.memory;t.update(d.usedJSHeapSize/
1048576,d.jsHeapSizeLimit/1048576)}return c},update:function(){k=this.end()},domElement:c,setMode:u}};f.Panel=function(e,f,l){var c=Infinity,k=0,g=Math.round,a=g(window.devicePixelRatio||1),r=80*a,h=48*a,t=3*a,v=2*a,d=3*a,m=15*a,n=74*a,p=30*a,q=document.createElement("canvas");q.width=r;q.height=h;q.style.cssText="width:80px;height:48px";var b=q.getContext("2d");b.font="bold "+9*a+"px Helvetica,Arial,sans-serif";b.textBaseline="top";b.fillStyle=l;b.fillRect(0,0,r,h);b.fillStyle=f;b.fillText(e,t,v);
b.fillRect(d,m,n,p);b.fillStyle=l;b.globalAlpha=.9;b.fillRect(d,m,n,p);return{dom:q,update:function(h,w){c=Math.min(c,h);k=Math.max(k,h);b.fillStyle=l;b.globalAlpha=1;b.fillRect(0,0,r,m);b.fillStyle=f;b.fillText(g(h)+" "+e+" ("+g(c)+"-"+g(k)+")",t,v);b.drawImage(q,d+a,m,n-a,p,d,m,n-a,p);b.fillRect(d+n-a,m,a,p);b.fillStyle=l;b.globalAlpha=.9;b.fillRect(d+n-a,m,a,g((1-h/w)*p))}}};return f});


/***/ })
/******/ ]);
});
//# sourceMappingURL=vue.js.map


//////////////////
// WEBPACK FOOTER
// /Users/brendon/Dev/www/vue/lib/vue.js
// module id = 36
// module chunks = d-game